/**
 * VerticalLandingPage Data
 *
 * Generated from Contentful export
 * Last updated: 2026-01-14T05:29:56.499Z
 *
 * ⚠️  IMPORTANT: This file contains embedded content references for rich text fields.
 * Do not manually edit the 'raw' or 'references' properties.
 */

export const verticalLandingPageData = [
  {
    id: '3oJgRQqnNJsnr0oeahfVDT',
    contentful_id: '3oJgRQqnNJsnr0oeahfVDT',
    createdAt: '2024-07-15T18:37:24.469Z',
    updatedAt: '2024-07-15T18:37:24.469Z',
    __typename: 'verticalLandingPage',
    internalTitle: 'FLATFILE FOR SYSTEM INTEGRATORS',
    urlSlug: 'system-integrators',
    hidePage: true,
    seo: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '3OIUY10r5UupQoqfnJz5Kk',
        type: 'Entry',
        createdAt: '2024-07-11T16:39:43.499Z',
        updatedAt: '2024-07-15T17:39:50.983Z',
        environment: null,
        publishedVersion: 13,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile for system integrators ',
        description:
          'Convert and onboard your customer’s data with ease to get them live faster and at a lower cost.'
      }
    },
    hero: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'BXl07q4CEzMBoepUsWA68',
        type: 'Entry',
        createdAt: '2024-07-11T16:45:03.487Z',
        updatedAt: '2024-07-15T17:40:45.477Z',
        environment: null,
        publishedVersion: 14,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Data migration made easy (si)',
        topHatText: 'FLATFILE FOR SYSTEM INTEGRATORS',
        heading: 'Data migration made easy',
        bodyText:
          'Flatfile’s AI-assisted data exchange platform is ideal for system integrators. Convert and onboard your customer’s data with ease to get them live faster, at lower cost and with full confidence that their organization’s cutover will be successful.',
        ctaButtons: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: 'bSVBPuZcHfX9SOBEvsk5i',
              type: 'Entry',
              createdAt: '2024-07-11T16:42:27.354Z',
              updatedAt: '2024-07-11T16:42:27.354Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Connect with an expert (si)',
              buttonText: 'Connect with an expert',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=si',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ],
        image: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '1JcNYypT01MqXsa29P7tMI',
            type: 'Asset',
            createdAt: '2024-07-11T16:44:55.334Z',
            updatedAt: '2024-07-11T16:44:55.334Z',
            environment: null,
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'si hero',
            description: null,
            file: {
              url: '/img/contentful/1JcNYypT-si-hero.webp',
              details: {
                size: 246844,
                image: {
                  width: 3178,
                  height: 1504
                }
              },
              fileName: 'si-hero.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    twoThirdsSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '3wZ4Ynyrpo3We8KHQZ5xla',
        type: 'Entry',
        createdAt: '2024-07-11T16:47:47.555Z',
        updatedAt: '2024-07-11T20:35:53.126Z',
        environment: null,
        publishedVersion: 10,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'two thirds content block (si)',
        topHatText: 'DON’T COMPROMISE',
        heading: 'Do these data migration problems sound familiar? ',
        checklist: [
          'Accurately mapping data from multiple sources to the target system is complex  and time-consuming ',
          'Migrating large volumes of data can overwhelm systems and staff,  causing delays and potential data loss',
          'Issues maintaining data quality and consistency during migration lead to inaccuracies',
          'Inconsistent data formats and lack of standardization complicate the migration process and increase errors '
        ],
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '1pe53BAcZDTQXjOtiERy4p',
              type: 'Entry',
              createdAt: '2024-07-11T20:35:45.624Z',
              updatedAt: '2024-07-11T20:35:45.624Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'we can help (si)',
              buttonText: 'We can help',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=si',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ]
      }
    },
    timedCarouselHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '7EdzS2rTgaphKOlSHcEpkx',
        type: 'Entry',
        createdAt: '2024-07-11T16:48:29.743Z',
        updatedAt: '2024-07-29T17:59:45.066Z',
        environment: null,
        publishedVersion: 9,
        revision: 3,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'timed carousel header (si)',
        heading: 'No more costly, services-heavy data migrations',
        bodyText:
          'Be a trusted advisor to your customers by avoiding costly, services-heavy data migrations. Implement efficient, scalable, and risk-mitigated workflows to optimize service hours and minimize downtime, significantly reducing the need for post-migration support.'
      }
    },
    timedCarouselItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '56sxt4zAUtmurICwREcKmV',
          type: 'Entry',
          createdAt: '2024-07-11T17:31:53.526Z',
          updatedAt: '2024-07-11T17:31:53.526Z',
          environment: null,
          publishedVersion: 11,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Accelerate time-to-value (si)',
          heading: 'Accelerate time-to-value',
          intro:
            'Speed up the onboarding process, ensuring your clients can start using their new systems faster',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '34NcycvdzYAvF6jUiaHZKu',
              type: 'Asset',
              createdAt: '2024-05-29T21:28:27.425Z',
              updatedAt: '2024-05-29T21:28:27.425Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'hcm-portal (1)',
              description: null,
              file: {
                url: '/img/contentful/34Ncycvd-hcm-portal__1_.webp',
                details: {
                  size: 7223,
                  image: {
                    width: 1184,
                    height: 786
                  }
                },
                fileName: 'hcm-portal (1).png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '12iV6V3BqKKMZM2HaHVLm4',
          type: 'Entry',
          createdAt: '2024-07-11T17:32:55.516Z',
          updatedAt: '2024-07-11T17:32:55.516Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Minimize development costs (si)',
          heading: 'Minimize development costs',
          intro:
            'Use automated tools and processes to optimize your resources, reducing the need for manual intervention and cutting down on operational costs ',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3nw2pfDnCQXIAEUi92hEtp',
              type: 'Asset',
              createdAt: '2024-05-30T20:22:39.181Z',
              updatedAt: '2024-05-30T20:22:39.181Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'hcm-minimize-img',
              description: null,
              file: {
                url: '/img/contentful/3nw2pfDn-hcm-minimize-img.webp',
                details: {
                  size: 5718,
                  image: {
                    width: 1134,
                    height: 506
                  }
                },
                fileName: 'hcm-minimize-img.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5h00cjnmF1LblNFnAlAfZi',
          type: 'Entry',
          createdAt: '2024-07-11T17:33:43.885Z',
          updatedAt: '2024-07-11T17:33:43.885Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Reduce data errors, increase data quality (si)',
          heading: 'Reduce data errors, increase data quality',
          intro:
            'Ensure customer data is consistent, clean and validated throughout the migration process. Remove data conversion blockers and business delays to enhance client satisfaction',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '77FzNY5BId6oCgC8DxO6UL',
              type: 'Asset',
              createdAt: '2024-05-30T20:23:48.595Z',
              updatedAt: '2024-05-30T20:23:48.595Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'hcm-reduce-img',
              description: null,
              file: {
                url: '/img/contentful/77FzNY5B-hcm-reduce-img.webp',
                details: {
                  size: 39784,
                  image: {
                    width: 1524,
                    height: 960
                  }
                },
                fileName: 'hcm-reduce-img.png',
                contentType: 'image/png'
              }
            }
          }
        }
      }
    ],
    waterfallSectionHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '1J3RsNhlo0csgBly7fCZNt',
        type: 'Entry',
        createdAt: '2024-07-11T21:26:18.856Z',
        updatedAt: '2024-07-11T21:26:18.856Z',
        environment: null,
        publishedVersion: 4,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'waterfall header (si)',
        heading: ' Seamless data migration with Flatfile',
        bodyText:
          'The Flatfile Data Exchange Platform provides all the tools your customers and your implementation teams need for a seamless data migration experience.'
      }
    },
    waterfallSectionItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '59lJaAlZdxLBxytH68XoKr',
          type: 'Entry',
          createdAt: '2024-07-11T20:30:04.828Z',
          updatedAt: '2024-07-15T18:35:59.104Z',
          environment: null,
          publishedVersion: 7,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title:
            'waterfall item - Automate tasks with AI-enhanced mapping (si)',
          heading: 'Automate tasks with AI-enhanced mapping',
          intro:
            'Stop sending Excel files back-and-forth via email. Flatfile’s AI-powered mapping converts customer data into your desired format. Automated validations and workflows ensure data is clean, approved, and production-ready—fast.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6UI847EIRXivjdwYFzJSwF',
              type: 'Asset',
              createdAt: '2024-07-11T20:29:42.029Z',
              updatedAt: '2024-07-11T20:29:42.029Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'automate-si',
              description: null,
              file: {
                url: '/img/contentful/6UI847EI-automate-si.webp',
                details: {
                  size: 109308,
                  image: {
                    width: 1222,
                    height: 744
                  }
                },
                fileName: 'automate-si.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '3oVsGyezKMJTEVu5gpm0P8',
          type: 'Entry',
          createdAt: '2024-07-11T20:30:59.573Z',
          updatedAt: '2024-07-11T20:30:59.573Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'waterfall item - Collaborate on data your way - (si)',
          heading: 'Collaborate on data your way',
          intro:
            'Streamline complex data workflows across diverse stakeholders. Onboard new customers or solve any collaborative need for importing, validating, editing and approving data. Granular access control and powerful data transformations ensure the right people manage the right data at the right time.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3svuVeJmsgDyo1g6kBVM6u',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:14.090Z',
              updatedAt: '2024-05-30T20:26:14.090Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'hcm-collab-img',
              description: null,
              file: {
                url: '/img/contentful/3svuVeJm-hcm-collab-img.webp',
                details: {
                  size: 56151,
                  image: {
                    width: 1164,
                    height: 782
                  }
                },
                fileName: 'hcm-collab-img.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '1yTLveBCDHYSIiqRQe9sp0',
          type: 'Entry',
          createdAt: '2024-07-11T20:31:50.633Z',
          updatedAt: '2024-07-15T18:36:44.126Z',
          environment: null,
          publishedVersion: 6,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title:
            'waterfall item - Tailored workflows for  varying customer needs (si)',
          heading: 'Tailored workflows for  varying customer needs',
          intro:
            'Customers bring highly unstructured and variable data that needs importing, validation, transformation and cleaning. Flatfile’s robust and extensible SDKs, APIs and plugins allow you to easily customize workflows and schemas to meet unique business needs—without the added effort.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3yz6FE0kOiwhEMMHf5aBVV',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:46.903Z',
              updatedAt: '2024-05-30T20:26:46.903Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'workflow-diagram',
              description: null,
              file: {
                url: '/img/contentful/3yz6FE0k-workflow-diagram.svg',
                details: {
                  size: 152828,
                  image: {
                    width: 520,
                    height: 440
                  }
                },
                fileName: 'workflow-diagram.svg',
                contentType: 'image/svg+xml'
              }
            }
          }
        }
      }
    ],
    guidedBlocksSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'QG2oQbQwwNLDSWiibr1GU',
        type: 'Entry',
        createdAt: '2024-07-11T20:56:14.056Z',
        updatedAt: '2024-07-11T20:56:14.056Z',
        environment: null,
        publishedVersion: 5,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        internalName: 'guided blocks (si)',
        title: 'Getting started is easy',
        cards: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7kUZsaWXFx3pBrAWakcmTJ',
              type: 'Entry',
              createdAt: '2024-07-11T20:54:31.312Z',
              updatedAt: '2024-07-11T20:56:00.288Z',
              environment: null,
              publishedVersion: 8,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Connect (si)',
              title: 'Connect',
              bodyText:
                'Learn how Flatfile transforms data migration as you know it',
              linkText: 'Connect with us',
              linkUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=si'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '1lfkaChqDnbCmzx1b7WLxu',
              type: 'Entry',
              createdAt: '2024-07-11T20:55:50.627Z',
              updatedAt: '2024-07-11T20:55:50.627Z',
              environment: null,
              publishedVersion: 8,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'demo (si)',
              title: 'Demo',
              bodyText: 'See how system integrators are using Flatfile',
              linkText: 'Check it out',
              linkUrl: '/demo/'
            }
          }
        ]
      }
    },
    platformOverviewHeading: 'Meet the Flatfile Data Exchange Platform',
    platformOverviewFeatures: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4PY0isKBdPxOCChfUh8K7m',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:07.060Z',
          updatedAt: '2024-05-29T21:04:07.060Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Built for developers',
          intro:
            'Flatfile’s robust API, SDKs and code-based approach provide true flexibility and control, unlike low-code solutions. Seamlessly integrates into your existing infrastructure with Git-based configuration and source control.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '6Teayyzp67P0UYw9mK1VHv',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:29.399Z',
          updatedAt: '2024-05-29T21:04:29.399Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Intuitive for end users',
          intro:
            'The familiar spreadsheet-style interface highlights errors and streamlines tasks like search, find, replace and sort. It ensures a seamless experience with fully customizable workflows and theming to align perfectly with your process and brand.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '3NbyYdglQbzTy3cN2D62p5',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:52.494Z',
          updatedAt: '2024-05-29T21:04:52.494Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Everything needed for file import',
          intro:
            'The industry’s most comprehensive data import experience at your fingertips, fully extensible with your own code. Import any data file type from any source. Clean data inconsistencies and formatting issues automatically.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5VSNemQ5JAxPbh1GIr0mZ7',
          type: 'Entry',
          createdAt: '2024-05-29T21:05:12.571Z',
          updatedAt: '2024-05-29T21:05:12.571Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Enterprise scale',
          intro:
            'Scalable and secure by default, Flatfile was built to meet rigorous enterprise security and compliance standards and provide the robust infrastructure necessary for large- scale data operations.'
        }
      }
    ],
    customerQuoteSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5lg6rjDTtcdgBK3AYjMKD8',
        type: 'Entry',
        createdAt: '2024-06-07T17:35:48.929Z',
        updatedAt: '2024-06-07T17:35:48.929Z',
        environment: null,
        publishedVersion: 5,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'workday quote',
        theme: true,
        body: "Flatfile's platform sets a new bar for data-exchange solutions, offering unparalleled flexibility and capability in coding… it's an indispensable tool for any developer",
        quotee: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '76tRbinWwVaUqOzgIFbyEK',
            type: 'Entry',
            createdAt: '2024-06-07T17:35:37.538Z',
            updatedAt: '2024-06-07T17:35:37.538Z',
            environment: null,
            publishedVersion: 6,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            fullName: 'Jonathan',
            headshot: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '683Iy5HG9J0IIX6mLsjhrU',
                type: 'Asset',
                createdAt: '2024-05-29T21:08:11.296Z',
                updatedAt: '2024-05-29T21:08:11.296Z',
                environment: null,
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'workday-photo',
                description: null,
                file: {
                  url: '/img/contentful/683Iy5HG-workday-photo.webp',
                  details: {
                    size: 960220,
                    image: {
                      width: 961,
                      height: 960
                    }
                  },
                  fileName: 'workday-photo.png',
                  contentType: 'image/png'
                }
              }
            },
            jobTitle: 'Data Conversion Tooling Automation',
            company: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '3x4XucyJ21QcpWE7dwufXq',
                type: 'Entry',
                createdAt: '2024-06-07T17:35:30.517Z',
                updatedAt: '2025-05-01T15:27:37.531Z',
                environment: null,
                publishedVersion: 12,
                revision: 3,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                name: 'Workday',
                logo: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '2iFrn6Vr2qH4nEUrT1UMgg',
                    type: 'Asset',
                    createdAt: '2025-05-01T15:27:16.941Z',
                    updatedAt: '2025-05-01T15:27:16.941Z',
                    environment: null,
                    publishedVersion: 3,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'workday-colored',
                    description: null,
                    file: {
                      url: '/img/contentful/2iFrn6Vr-workday-colored.webp',
                      details: {
                        size: 41322,
                        image: {
                          width: 800,
                          height: 322
                        }
                      },
                      fileName: 'workday-colored.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoBlack: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '2JyQW1Mi5Xwz6SJGVxTnae',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.144Z',
                    updatedAt: '2024-04-29T20:24:29.144Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'workday',
                    file: {
                      url: '/img/contentful/2JyQW1Mi-workday.webp',
                      details: {
                        size: 2879,
                        image: {
                          width: 160,
                          height: 64
                        }
                      },
                      fileName: 'workday.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoWhite: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '6yWUo6SbJ93uwpxqkQCFjY',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.222Z',
                    updatedAt: '2024-04-29T20:24:29.222Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'workday-white',
                    file: {
                      url: '/img/contentful/6yWUo6Sb-workday-white.webp',
                      details: {
                        size: 2332,
                        image: {
                          width: 160,
                          height: 64
                        }
                      },
                      fileName: 'workday-white.png',
                      contentType: 'image/png'
                    }
                  }
                }
              }
            }
          }
        },
        photo: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '683Iy5HG9J0IIX6mLsjhrU',
            type: 'Asset',
            createdAt: '2024-05-29T21:08:11.296Z',
            updatedAt: '2024-05-29T21:08:11.296Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'workday-photo',
            description: null,
            file: {
              url: '/img/contentful/683Iy5HG-workday-photo.webp',
              details: {
                size: 960220,
                image: {
                  width: 961,
                  height: 960
                }
              },
              fileName: 'workday-photo.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    showWayfinder: null
  },
  {
    id: '27uiMT5DpYayGwzF9omGfS',
    contentful_id: '27uiMT5DpYayGwzF9omGfS',
    createdAt: '2024-06-07T17:35:57.419Z',
    updatedAt: '2024-06-07T22:31:18.490Z',
    __typename: 'verticalLandingPage',
    internalTitle: 'hcm',
    urlSlug: 'hcm',
    hidePage: null,
    seo: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '4nl2gclT5A0wDeQ2yJ5eby',
        type: 'Entry',
        createdAt: '2024-06-07T17:23:03.914Z',
        updatedAt: '2024-06-07T17:23:03.914Z',
        environment: null,
        publishedVersion: 4,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Data conversion made easy',
        description:
          'Convert & onboard your customer’s data with ease so that you get them live faster, at lower cost and with full confidence that their cutover will be successful.'
      }
    },
    hero: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '56NVsUn46Mppd7JUDMS60a',
        type: 'Entry',
        createdAt: '2024-06-07T17:24:46.579Z',
        updatedAt: '2024-06-07T17:24:46.579Z',
        environment: null,
        publishedVersion: 7,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'hcm hero',
        topHatText: 'FLATFILE FOR HUMAN CAPITAL MANAGEMENT',
        heading: 'Data conversion made easy',
        bodyText:
          'Flatfile’s AI-assisted data exchange platform is ideal for HCM companies. Convert and onboard your customer’s data with ease so that you get them live faster, at lower cost and with full confidence that their organization’s cutover will be successful.',
        ctaButtons: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '62YfdnaBFGnongXkGOu69U',
              type: 'Entry',
              createdAt: '2024-06-07T17:24:05.493Z',
              updatedAt: '2024-06-07T17:24:05.493Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Connect with an expert (hcm)',
              buttonText: 'Connect with an expert',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=hcm',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4tfuEAsTyqj4vZmrnbPfUX',
              type: 'Entry',
              createdAt: '2024-06-07T17:24:33.879Z',
              updatedAt: '2024-06-07T17:24:33.879Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'See how it works (hcm)',
              buttonText: 'See how it works',
              buttonUrl: '/vertical/hcm/#videoBlock',
              onPageAnchor: null,
              buttonStyle: 'Secondary'
            }
          }
        ],
        image: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: 'M6XpgWCvQSX7irmmYvoC3',
            type: 'Asset',
            createdAt: '2024-06-07T16:33:24.041Z',
            updatedAt: '2024-06-07T22:22:01.334Z',
            environment: null,
            publishedVersion: 8,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'hcm-hero',
            description: null,
            file: {
              url: '/img/contentful/M6XpgWCv-hcm-hero__1_.webp',
              details: {
                size: 249988,
                image: {
                  width: 3178,
                  height: 1504
                }
              },
              fileName: 'hcm-hero (1).png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    logoBanner: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '3GX6YTvvs5ZS5gHbaweUn8',
        type: 'Entry',
        createdAt: '2024-06-07T17:25:42.120Z',
        updatedAt: '2024-06-07T17:25:42.120Z',
        environment: null,
        publishedVersion: 8,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        name: 'hcm logo bar',
        title: 'TRUSTED BY THE WORLD’S LEADING HCM ORGANIZATIONS',
        logos: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5A8fk63Or8Yj5mtcQLBS2q',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.200Z',
              updatedAt: '2024-04-29T20:24:29.200Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'adp',
              file: {
                url: '/img/contentful/5A8fk63O-adp.webp',
                details: {
                  size: 1789,
                  image: {
                    width: 122,
                    height: 80
                  }
                },
                fileName: 'adp.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2JyQW1Mi5Xwz6SJGVxTnae',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.144Z',
              updatedAt: '2024-04-29T20:24:29.144Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'workday',
              file: {
                url: '/img/contentful/2JyQW1Mi-workday.webp',
                details: {
                  size: 2879,
                  image: {
                    width: 160,
                    height: 64
                  }
                },
                fileName: 'workday.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6Lpjd7dNplhFCNMMhrSisN',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.214Z',
              updatedAt: '2024-04-29T20:24:29.214Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'deputy',
              file: {
                url: '/img/contentful/6Lpjd7dN-deputy.webp',
                details: {
                  size: 2908,
                  image: {
                    width: 238,
                    height: 56
                  }
                },
                fileName: 'deputy.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6llhFWxPN3vmd76DVzQrHZ',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.212Z',
              updatedAt: '2024-04-29T20:24:29.212Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'beeline',
              file: {
                url: '/img/contentful/6llhFWxP-beeline.webp',
                details: {
                  size: 2369,
                  image: {
                    width: 224,
                    height: 48
                  }
                },
                fileName: 'beeline.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '30XInI4o64TlPGKCKxgzp1',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.154Z',
              updatedAt: '2024-04-29T20:24:29.154Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'kallidus',
              file: {
                url: '/img/contentful/30XInI4o-kallidus.webp',
                details: {
                  size: 5893,
                  image: {
                    width: 200,
                    height: 64
                  }
                },
                fileName: 'kallidus.png',
                contentType: 'image/png'
              }
            }
          }
        ],
        theme: 'Light'
      }
    },
    twoThirdsSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5aZIWbNB9jCgK2yYnHW9p6',
        type: 'Entry',
        createdAt: '2024-06-07T17:27:28.996Z',
        updatedAt: '2024-06-07T20:44:15.063Z',
        environment: null,
        publishedVersion: 9,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Do these common data conversion problems sound familiar? (HCM)',
        topHatText: 'DON’T COMPROMISE',
        heading: 'Do these common data conversion problems sound familiar?',
        checklist: [
          'Hours and resources wasted on redundant data conversion tasks',
          'Customer friction caused by complicated data onboarding processes',
          'Delayed customer activation caused by rigid workflows',
          'Decreased bandwidth due to slow implementation speeds'
        ],
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4M6TIFTxShbw2GIKlLwYaD',
              type: 'Entry',
              createdAt: '2024-06-07T17:27:21.817Z',
              updatedAt: '2024-06-07T17:27:21.817Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Learn how Flatfile can help (hcm)',
              buttonText: 'Learn how Flatfile can help',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=hcm',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ]
      }
    },
    timedCarouselHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '7nJ2j3LTaSEG8Q0Wsb4kEJ',
        type: 'Entry',
        createdAt: '2024-06-07T17:27:47.850Z',
        updatedAt: '2024-06-07T17:27:47.850Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle:
          'No more costly, services-heavy data conversion processes (hcm)',
        heading: 'No more costly, services-heavy data conversion processes',
        bodyText:
          "If you have customers using your software applications, loading those apps with data is a necessary first step before the customer will get any value from using your software or service. Any delay or complication in getting their data into your app will affect your customer's ROI and can impact your revenue."
      }
    },
    timedCarouselItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '1gnRSx70gC5R89CYzRkSLB',
          type: 'Entry',
          createdAt: '2024-06-07T17:28:17.860Z',
          updatedAt: '2024-06-27T19:29:23.909Z',
          environment: null,
          publishedVersion: 6,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Accelerate time-to-value (hcm)',
          heading: 'Accelerate time-to-value',
          intro:
            'Get customer data into your systems faster with a data mapping and import experience your business needs and your users will love -- without delay or compromises.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7eryG6k4KY2yEEqhBXP2Wq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:17.532Z',
              updatedAt: '2024-06-27T19:24:17.532Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'accelerate time to value',
              description: null,
              file: {
                url: '/img/contentful/7eryG6k4-accelerate_time_to_value.webp',
                details: {
                  size: 15901,
                  image: {
                    width: 801,
                    height: 406
                  }
                },
                fileName: 'Accelerate Time to Value.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '73VbDuTyPN0C0nreYpIdQa',
          type: 'Entry',
          createdAt: '2024-06-07T17:28:44.332Z',
          updatedAt: '2024-06-27T19:29:36.016Z',
          environment: null,
          publishedVersion: 6,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Minimize in-house services & development costs (hcm)',
          heading: 'Minimize in-house services & development costs',
          intro:
            'Keep limited and expensive engineering resources focused on your unique business differentiators without the distraction, cost and time it takes to build data import functionality.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: 'SlNCDNMdLILgoJ0tg2Gvq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:45.736Z',
              updatedAt: '2024-06-27T19:24:45.736Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Minimize in-house costs',
              description: null,
              file: {
                url: '/img/contentful/SlNCDNMd-minimize_inhouse_costs.webp',
                details: {
                  size: 16038,
                  image: {
                    width: 818,
                    height: 439
                  }
                },
                fileName: 'Minimize inhouse costs.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: 'EznGsx6MPTQtCDrxq7IHx',
          type: 'Entry',
          createdAt: '2024-06-07T17:29:11.801Z',
          updatedAt: '2024-06-27T19:29:45.456Z',
          environment: null,
          publishedVersion: 6,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Reduce data errors, increase data quality (hcm)',
          heading: 'Reduce data errors, increase data quality',
          intro:
            'Make sure customer data is consistent, clean and validated for go-live. Remove data conversion blockers and business delays and lessen the likelihood that critical data issues will create unnecessary fire drills.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2tlUqPKcZwQSpelyGsQy3X',
              type: 'Asset',
              createdAt: '2024-06-27T19:25:13.124Z',
              updatedAt: '2024-06-27T19:25:13.124Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Reduce data errors',
              description: null,
              file: {
                url: '/img/contentful/2tlUqPKc-reduce_data_errors.webp',
                details: {
                  size: 13842,
                  image: {
                    width: 814,
                    height: 395
                  }
                },
                fileName: 'Reduce data errors.png',
                contentType: 'image/png'
              }
            }
          }
        }
      }
    ],
    waterfallSectionHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'A0UgpXHwhHoMz34ZlAHMt',
        type: 'Entry',
        createdAt: '2024-06-07T17:29:38.699Z',
        updatedAt: '2024-06-07T17:29:38.699Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Seamless data onboarding with Flatfile (hcm)',
        heading: 'Seamless data onboarding with Flatfile',
        bodyText:
          'The Flatfile Data Exchange Platform provides all the tools your customers and your implementation teams need for a seamless data onboarding experience.'
      }
    },
    waterfallSectionItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5NiLi8KKsOp5qlZgnmyUeS',
          type: 'Entry',
          createdAt: '2024-06-07T17:30:05.786Z',
          updatedAt: '2024-06-07T17:30:05.786Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Automate tasks with AI-enhanced mapping (hcm)',
          heading: 'Automate tasks with AI-enhanced mapping',
          intro:
            'Stop sending Excel files back-and-forth via email. Flatfile’s AI powered source to target mapping auto-magically converts customer data into your desired format. Automated validations, transformations and workflows ensure data is squeaky clean, approved and ready for production -- faster.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3ZAouVb8yMECmFTlNTBApb',
              type: 'Asset',
              createdAt: '2024-05-30T20:25:34.299Z',
              updatedAt: '2024-05-30T20:25:34.299Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'visual-diff',
              description: null,
              file: {
                url: '/img/contentful/3ZAouVb8-visual-diff.webp',
                details: {
                  size: 35605,
                  image: {
                    width: 1120,
                    height: 598
                  }
                },
                fileName: 'visual-diff.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5tlyVAf2rYsFyYtQ2YUNjD',
          type: 'Entry',
          createdAt: '2024-06-07T17:30:30.316Z',
          updatedAt: '2024-06-07T17:30:30.316Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Collaborate on data your way (hcm)',
          heading: 'Collaborate on data your way',
          intro:
            'Streamline complex data workflows across diverse stakeholders. Onboard new customers or solve any collaborative need for importing, validating, editing and approving data. Granular access control and powerful data transformations ensure the right people manage the right data at the right time.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3svuVeJmsgDyo1g6kBVM6u',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:14.090Z',
              updatedAt: '2024-05-30T20:26:14.090Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'hcm-collab-img',
              description: null,
              file: {
                url: '/img/contentful/3svuVeJm-hcm-collab-img.webp',
                details: {
                  size: 56151,
                  image: {
                    width: 1164,
                    height: 782
                  }
                },
                fileName: 'hcm-collab-img.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4xy8XeJfpFl4YiXWBvh8qi',
          type: 'Entry',
          createdAt: '2024-06-07T17:30:55.637Z',
          updatedAt: '2024-06-07T17:30:55.637Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Tailored workflows for varying customer needs (hcm)',
          heading: 'Tailored workflows for varying customer needs',
          intro:
            'Customers bring highly unstructured and variable data that needs to be imported, validated, transformed and cleaned. Flatfile’s robust and extensible SDKs, APIs and plugins enable you to easily cater to and personalize your workflows and schemas to a customers needs -- without the added effort.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3yz6FE0kOiwhEMMHf5aBVV',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:46.903Z',
              updatedAt: '2024-05-30T20:26:46.903Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'workflow-diagram',
              description: null,
              file: {
                url: '/img/contentful/3yz6FE0k-workflow-diagram.svg',
                details: {
                  size: 152828,
                  image: {
                    width: 520,
                    height: 440
                  }
                },
                fileName: 'workflow-diagram.svg',
                contentType: 'image/svg+xml'
              }
            }
          }
        }
      }
    ],
    webinarSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '7Jc52qDpVw6pmyVHD0HAKG',
        type: 'Entry',
        createdAt: '2024-06-07T17:31:47.894Z',
        updatedAt: '2024-06-07T22:43:59.974Z',
        environment: null,
        publishedVersion: 6,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title:
          "See how Flatfile's AI-assisted data conversion can accelerate HCM implementation projects (hcm)",
        topHatText: 'WEBINAR',
        heading:
          "See how Flatfile's AI-assisted data conversion can accelerate HCM implementation projects",
        intro:
          'Leading HCM providers depend on AI-enabled data exchange platforms like Flatfile to eliminate customer concerns and ensure a quick, easy and reliable cutover of systems that allows them to onboard more customers faster and at lower cost.',
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6xvp6Y33Q2NCG94og5FJLL',
              type: 'Entry',
              createdAt: '2024-06-07T17:31:41.332Z',
              updatedAt: '2024-06-07T17:31:41.332Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Get a personalized demo (hcm)',
              buttonText: 'Get a personalized demo',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=hcm',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ],
        video: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '43UQ8F5a4zyM7Uxd3lnTsw',
            type: 'Entry',
            createdAt: '2024-04-26T16:55:13.881Z',
            updatedAt: '2024-04-26T16:55:13.881Z',
            environment: null,
            publishedVersion: 2,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            title: 'HCM',
            video: {
              items: [
                {
                  hashed_id: 'l3ehvdqltn',
                  id: 118541943,
                  duration: 2671.25,
                  thumbnail: {
                    url: 'https://embed-ssl.wistia.com/deliveries/5d6062b9b460e9da4e53e6ce9b71ed22.jpg?image_crop_resized=200x120',
                    width: 200,
                    height: 120
                  }
                }
              ]
            }
          }
        }
      }
    },
    guidedBlocksSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'iuAtIFkk5smHzSEdIhjPa',
        type: 'Entry',
        createdAt: '2024-06-07T17:33:23.543Z',
        updatedAt: '2024-06-07T17:33:23.543Z',
        environment: null,
        publishedVersion: 4,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        internalName: 'Getting started is easy (HCM)',
        topHatText: "LET'S TALK",
        title: 'Getting started is easy',
        cards: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5izMIaZj8rrKnq74gQ457m',
              type: 'Entry',
              createdAt: '2024-06-07T17:32:45.535Z',
              updatedAt: '2024-06-07T17:32:45.535Z',
              environment: null,
              publishedVersion: 6,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Connect (hcm)',
              title: 'Connect',
              bodyText:
                'Learn how Flatfile transforms data onboarding as you know it',
              linkText: 'Connect with us',
              linkUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=hcm'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2rBmifbuFAsMnR4UuSoevp',
              type: 'Entry',
              createdAt: '2024-06-07T17:33:19.118Z',
              updatedAt: '2024-06-07T17:33:19.118Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Demo (HCM)',
              title: 'Demo',
              bodyText: 'See how HCM companies are using Flatfile',
              linkText: 'Check it out',
              linkUrl:
                '/resources/webinars/how-ai-assisted-data-conversion-can-accelerate-implementation-projects/'
            }
          }
        ]
      }
    },
    platformOverviewHeading: 'Meet the Flatfile Data Exchange Platform',
    platformOverviewFeatures: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4PY0isKBdPxOCChfUh8K7m',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:07.060Z',
          updatedAt: '2024-05-29T21:04:07.060Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Built for developers',
          intro:
            'Flatfile’s robust API, SDKs and code-based approach provide true flexibility and control, unlike low-code solutions. Seamlessly integrates into your existing infrastructure with Git-based configuration and source control.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '6Teayyzp67P0UYw9mK1VHv',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:29.399Z',
          updatedAt: '2024-05-29T21:04:29.399Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Intuitive for end users',
          intro:
            'The familiar spreadsheet-style interface highlights errors and streamlines tasks like search, find, replace and sort. It ensures a seamless experience with fully customizable workflows and theming to align perfectly with your process and brand.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '3NbyYdglQbzTy3cN2D62p5',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:52.494Z',
          updatedAt: '2024-05-29T21:04:52.494Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Everything needed for file import',
          intro:
            'The industry’s most comprehensive data import experience at your fingertips, fully extensible with your own code. Import any data file type from any source. Clean data inconsistencies and formatting issues automatically.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5VSNemQ5JAxPbh1GIr0mZ7',
          type: 'Entry',
          createdAt: '2024-05-29T21:05:12.571Z',
          updatedAt: '2024-05-29T21:05:12.571Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Enterprise scale',
          intro:
            'Scalable and secure by default, Flatfile was built to meet rigorous enterprise security and compliance standards and provide the robust infrastructure necessary for large- scale data operations.'
        }
      }
    ],
    customerQuoteSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5lg6rjDTtcdgBK3AYjMKD8',
        type: 'Entry',
        createdAt: '2024-06-07T17:35:48.929Z',
        updatedAt: '2024-06-07T17:35:48.929Z',
        environment: null,
        publishedVersion: 5,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'workday quote',
        theme: true,
        body: "Flatfile's platform sets a new bar for data-exchange solutions, offering unparalleled flexibility and capability in coding… it's an indispensable tool for any developer",
        quotee: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '76tRbinWwVaUqOzgIFbyEK',
            type: 'Entry',
            createdAt: '2024-06-07T17:35:37.538Z',
            updatedAt: '2024-06-07T17:35:37.538Z',
            environment: null,
            publishedVersion: 6,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            fullName: 'Jonathan',
            headshot: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '683Iy5HG9J0IIX6mLsjhrU',
                type: 'Asset',
                createdAt: '2024-05-29T21:08:11.296Z',
                updatedAt: '2024-05-29T21:08:11.296Z',
                environment: null,
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'workday-photo',
                description: null,
                file: {
                  url: '/img/contentful/683Iy5HG-workday-photo.webp',
                  details: {
                    size: 960220,
                    image: {
                      width: 961,
                      height: 960
                    }
                  },
                  fileName: 'workday-photo.png',
                  contentType: 'image/png'
                }
              }
            },
            jobTitle: 'Data Conversion Tooling Automation',
            company: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '3x4XucyJ21QcpWE7dwufXq',
                type: 'Entry',
                createdAt: '2024-06-07T17:35:30.517Z',
                updatedAt: '2025-05-01T15:27:37.531Z',
                environment: null,
                publishedVersion: 12,
                revision: 3,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                name: 'Workday',
                logo: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '2iFrn6Vr2qH4nEUrT1UMgg',
                    type: 'Asset',
                    createdAt: '2025-05-01T15:27:16.941Z',
                    updatedAt: '2025-05-01T15:27:16.941Z',
                    environment: null,
                    publishedVersion: 3,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'workday-colored',
                    description: null,
                    file: {
                      url: '/img/contentful/2iFrn6Vr-workday-colored.webp',
                      details: {
                        size: 41322,
                        image: {
                          width: 800,
                          height: 322
                        }
                      },
                      fileName: 'workday-colored.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoBlack: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '2JyQW1Mi5Xwz6SJGVxTnae',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.144Z',
                    updatedAt: '2024-04-29T20:24:29.144Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'workday',
                    file: {
                      url: '/img/contentful/2JyQW1Mi-workday.webp',
                      details: {
                        size: 2879,
                        image: {
                          width: 160,
                          height: 64
                        }
                      },
                      fileName: 'workday.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoWhite: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '6yWUo6SbJ93uwpxqkQCFjY',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.222Z',
                    updatedAt: '2024-04-29T20:24:29.222Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'workday-white',
                    file: {
                      url: '/img/contentful/6yWUo6Sb-workday-white.webp',
                      details: {
                        size: 2332,
                        image: {
                          width: 160,
                          height: 64
                        }
                      },
                      fileName: 'workday-white.png',
                      contentType: 'image/png'
                    }
                  }
                }
              }
            }
          }
        },
        photo: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '683Iy5HG9J0IIX6mLsjhrU',
            type: 'Asset',
            createdAt: '2024-05-29T21:08:11.296Z',
            updatedAt: '2024-05-29T21:08:11.296Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'workday-photo',
            description: null,
            file: {
              url: '/img/contentful/683Iy5HG-workday-photo.webp',
              details: {
                size: 960220,
                image: {
                  width: 961,
                  height: 960
                }
              },
              fileName: 'workday-photo.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    showWayfinder: true
  },
  {
    id: '1UpPr9RRxGJ1RyGaGfidHk',
    contentful_id: '1UpPr9RRxGJ1RyGaGfidHk',
    createdAt: '2024-05-30T20:29:13.628Z',
    updatedAt: '2024-06-07T22:31:11.779Z',
    __typename: 'verticalLandingPage',
    internalTitle: 'Field Services',
    urlSlug: 'field-services',
    hidePage: null,
    seo: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '61lZDF1Mjsv8FEDDrWnaqW',
        type: 'Entry',
        createdAt: '2024-05-30T20:51:15.893Z',
        updatedAt: '2024-06-07T16:15:58.669Z',
        environment: null,
        publishedVersion: 7,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Accelerate data migration',
        description:
          'Efficiently prepare and migrate data for system implementation projects, ensuring faster go-live, lower costs, and improved confidence in data quality'
      }
    },
    hero: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '15AIdGdZSVNBEjB5Y9LBIt',
        type: 'Entry',
        createdAt: '2024-05-29T21:15:39.564Z',
        updatedAt: '2024-05-30T20:10:57.321Z',
        environment: null,
        publishedVersion: 14,
        revision: 4,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Field Services hero',
        topHatText: 'FLATFILE FOR FIELD SERVICE MANAGEMENT (FSM) SOFTWARE',
        heading: 'Customer data migration, simplified',
        bodyText:
          'Flatfile’s AI-assisted data exchange platform is ideal for Field Service Management (FSM) software. Convert and migrate your customer’s data with ease so that you get them live faster, at lower cost and with full confidence in data quality.',
        ctaButtons: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6Fkfw0iPKgUjWC93uvSooa',
              type: 'Entry',
              createdAt: '2024-05-29T21:14:35.020Z',
              updatedAt: '2024-05-30T19:44:45.793Z',
              environment: null,
              publishedVersion: 8,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Connect with an expert (field services)',
              buttonText: 'Connect with an expert',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=field-services',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3wSO6Vxkx951F3BZfHkQNa',
              type: 'Entry',
              createdAt: '2024-05-29T21:15:14.354Z',
              updatedAt: '2024-06-06T18:07:01.898Z',
              environment: null,
              publishedVersion: 6,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'See how it works (on page anchor)',
              buttonText: 'See how it works',
              buttonUrl: '#videoBlock',
              onPageAnchor: true,
              buttonStyle: 'Secondary'
            }
          }
        ],
        image: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '7vURYSitblRXJPj7OQtLdX',
            type: 'Asset',
            createdAt: '2024-05-30T20:10:46.918Z',
            updatedAt: '2024-05-30T20:10:46.918Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'fieldops-hero',
            description: null,
            file: {
              url: '/img/contentful/7vURYSit-fieldops-hero.avif.webp',
              details: {
                size: 52829,
                image: {
                  width: 1577,
                  height: 746
                }
              },
              fileName: 'fieldops-hero.avif',
              contentType: 'image/avif'
            }
          }
        }
      }
    },
    logoBanner: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: 'jsi0H3zgCxpwTxydmH5Rg',
        type: 'Entry',
        createdAt: '2024-05-30T20:12:21.943Z',
        updatedAt: '2024-06-06T18:20:43.394Z',
        environment: null,
        publishedVersion: 7,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        name: 'Field services',
        title: 'TRUSTED BY THE WORLD’S LEADING FIELD SERVICES ORGANIZATIONS',
        logos: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3WYIAgYYoXS7eadLxhkBVK',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.191Z',
              updatedAt: '2024-04-29T20:24:29.191Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'servicetitan',
              file: {
                url: '/img/contentful/3WYIAgYY-servicetitan.webp',
                details: {
                  size: 5183,
                  image: {
                    width: 376,
                    height: 64
                  }
                },
                fileName: 'servicetitan.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '15v8553XAxmAi9b1aYNjdz',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.119Z',
              updatedAt: '2024-04-29T20:24:29.119Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'jobber',
              file: {
                url: '/img/contentful/15v8553X-jobber.webp',
                details: {
                  size: 3095,
                  image: {
                    width: 342,
                    height: 56
                  }
                },
                fileName: 'jobber.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3S1KJ9rPIuIdDULLvAF8Pn',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.165Z',
              updatedAt: '2024-04-29T20:24:29.165Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'housecallpro',
              file: {
                url: '/img/contentful/3S1KJ9rP-housecallpro.webp',
                details: {
                  size: 3531,
                  image: {
                    width: 400,
                    height: 80
                  }
                },
                fileName: 'housecallpro.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '1NKL9mMoLhx7nSwAZaTSKe',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.128Z',
              updatedAt: '2024-04-29T20:24:29.128Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'buildops',
              file: {
                url: '/img/contentful/1NKL9mMo-buildops.webp',
                details: {
                  size: 10706,
                  image: {
                    width: 280,
                    height: 56
                  }
                },
                fileName: 'buildops.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6llhFWxPN3vmd76DVzQrHZ',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.212Z',
              updatedAt: '2024-04-29T20:24:29.212Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'beeline',
              file: {
                url: '/img/contentful/6llhFWxP-beeline.webp',
                details: {
                  size: 2369,
                  image: {
                    width: 224,
                    height: 48
                  }
                },
                fileName: 'beeline.png',
                contentType: 'image/png'
              }
            }
          }
        ],
        theme: 'Light'
      }
    },
    twoThirdsSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '7fFPEEXN14u2hmC4MQSk3',
        type: 'Entry',
        createdAt: '2024-05-29T21:19:42.155Z',
        updatedAt: '2024-05-30T20:13:19.202Z',
        environment: null,
        publishedVersion: 9,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Do these common data migration problems sound familiar?',
        topHatText: 'DON’T COMPROMISE',
        heading: 'Do these common data migration problems sound familiar?',
        checklist: [
          'Hours and resources wasted on redundant data migration tasks',
          'Customer friction caused by complicated data onboarding processes',
          'Delayed customer activation caused by rigid and manual workflows',
          'Decreased bandwidth due to slow implementation speeds'
        ],
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6ztXsUvnfluKcp2nTC8mhV',
              type: 'Entry',
              createdAt: '2024-05-29T21:19:32.050Z',
              updatedAt: '2024-06-07T22:45:20.493Z',
              environment: null,
              publishedVersion: 10,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Learn how Flatfile can help (field-services)',
              buttonText: 'Learn how we can help',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=field-services',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ]
      }
    },
    timedCarouselHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '21JXZQhCnvRZhoaKSrWVPJ',
        type: 'Entry',
        createdAt: '2024-05-29T21:20:57.068Z',
        updatedAt: '2024-05-29T21:22:44.523Z',
        environment: null,
        publishedVersion: 4,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'No more costly, services-heavy data migration processes',
        heading: 'No more costly, services-heavy data migration processes',
        bodyText:
          "If you have customers using your software applications, loading those apps with data is a necessary first step before the customer will get any value from using your software or service. Any delay or complication in getting their data into your app will affect your customer's ROI and can impact your revenue."
      }
    },
    timedCarouselItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '1Fv0VTxaMq8qc25327yKqC',
          type: 'Entry',
          createdAt: '2024-05-29T21:24:21.638Z',
          updatedAt: '2024-06-27T19:30:08.070Z',
          environment: null,
          publishedVersion: 11,
          revision: 3,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Accelerate time-to-value (field services)',
          heading: 'Accelerate time-to-value',
          intro:
            'Get customer data into your systems faster with a data mapping and import experience your business needs and your users will love -- without delay or compromises.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7eryG6k4KY2yEEqhBXP2Wq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:17.532Z',
              updatedAt: '2024-06-27T19:24:17.532Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'accelerate time to value',
              description: null,
              file: {
                url: '/img/contentful/7eryG6k4-accelerate_time_to_value.webp',
                details: {
                  size: 15901,
                  image: {
                    width: 801,
                    height: 406
                  }
                },
                fileName: 'Accelerate Time to Value.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '2dmzT1n6Jlu5Sq3i5L5kP6',
          type: 'Entry',
          createdAt: '2024-05-30T20:22:48.794Z',
          updatedAt: '2024-06-27T19:30:19.582Z',
          environment: null,
          publishedVersion: 7,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title:
            'Minimize in-house services & development costs (field services)',
          heading: 'Minimize in-house services & development costs',
          intro:
            'Keep limited and expensive engineering resources focused on your unique business differentiators without the distraction, cost and time it takes to build data import functionality.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: 'SlNCDNMdLILgoJ0tg2Gvq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:45.736Z',
              updatedAt: '2024-06-27T19:24:45.736Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Minimize in-house costs',
              description: null,
              file: {
                url: '/img/contentful/SlNCDNMd-minimize_inhouse_costs.webp',
                details: {
                  size: 16038,
                  image: {
                    width: 818,
                    height: 439
                  }
                },
                fileName: 'Minimize inhouse costs.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '1V9IhJwrgDFnzI5J0xyc6K',
          type: 'Entry',
          createdAt: '2024-05-30T20:23:53.834Z',
          updatedAt: '2024-06-27T19:30:30.760Z',
          environment: null,
          publishedVersion: 6,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Reduce data errors, increase data quality (field services)',
          heading: 'Reduce data errors, increase data quality',
          intro:
            'Make sure customer data is consistent, clean and validated for go-live. Remove data conversion blockers and business delays and lessen the likelihood that critical data issues will create unnecessary fire drills.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2tlUqPKcZwQSpelyGsQy3X',
              type: 'Asset',
              createdAt: '2024-06-27T19:25:13.124Z',
              updatedAt: '2024-06-27T19:25:13.124Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Reduce data errors',
              description: null,
              file: {
                url: '/img/contentful/2tlUqPKc-reduce_data_errors.webp',
                details: {
                  size: 13842,
                  image: {
                    width: 814,
                    height: 395
                  }
                },
                fileName: 'Reduce data errors.png',
                contentType: 'image/png'
              }
            }
          }
        }
      }
    ],
    waterfallSectionHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '39vie9pLO7t9tW3PGLrYvM',
        type: 'Entry',
        createdAt: '2024-05-29T21:32:22.336Z',
        updatedAt: '2024-05-29T21:32:22.336Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Seamless data onboarding with Flatfile',
        heading: 'Seamless data onboarding with Flatfile',
        bodyText:
          'The Flatfile Data Exchange Platform provides all the tools your customers and your implementation teams need for a seamless data onboarding experience.'
      }
    },
    waterfallSectionItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '2KscTmWtF47vghpo7owIvY',
          type: 'Entry',
          createdAt: '2024-05-30T20:25:43.392Z',
          updatedAt: '2024-05-30T20:25:43.392Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Automate tasks with AI-enhanced mapping',
          heading: 'Automate tasks with AI-enhanced mapping',
          intro:
            'Stop sending Excel files back-and-forth via email. Flatfile’s AI powered source to target mapping auto-magically converts customer data into your desired format. Automated validations, transformations and workflows ensure data is squeaky clean, approved and ready for production -- faster.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3ZAouVb8yMECmFTlNTBApb',
              type: 'Asset',
              createdAt: '2024-05-30T20:25:34.299Z',
              updatedAt: '2024-05-30T20:25:34.299Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'visual-diff',
              description: null,
              file: {
                url: '/img/contentful/3ZAouVb8-visual-diff.webp',
                details: {
                  size: 35605,
                  image: {
                    width: 1120,
                    height: 598
                  }
                },
                fileName: 'visual-diff.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5gq8h8E52FnFBOlli961oK',
          type: 'Entry',
          createdAt: '2024-05-30T20:26:19.176Z',
          updatedAt: '2024-05-30T20:26:19.176Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Collaborate on data your way',
          heading: 'Collaborate on data your way',
          intro:
            'Streamline complex data workflows across diverse stakeholders. Onboard new customers or solve any collaborative need for importing, validating, editing and approving data. Granular access control and powerful data transformations ensure the right people manage the right data at the right time.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3svuVeJmsgDyo1g6kBVM6u',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:14.090Z',
              updatedAt: '2024-05-30T20:26:14.090Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'hcm-collab-img',
              description: null,
              file: {
                url: '/img/contentful/3svuVeJm-hcm-collab-img.webp',
                details: {
                  size: 56151,
                  image: {
                    width: 1164,
                    height: 782
                  }
                },
                fileName: 'hcm-collab-img.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5XZJ1JlQlqJeV9WuyoGPoL',
          type: 'Entry',
          createdAt: '2024-05-30T20:26:51.337Z',
          updatedAt: '2024-05-30T20:26:51.337Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Tailored workflows for varying customer needs',
          heading: 'Tailored workflows for varying customer needs',
          intro:
            'Customers bring highly unstructured and variable data that needs to be imported, validated, transformed and cleaned. Flatfile’s robust and extensible SDKs, APIs and plugins enable you to easily cater to and personalize your workflows and schemas to a customers needs -- without the added effort.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3yz6FE0kOiwhEMMHf5aBVV',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:46.903Z',
              updatedAt: '2024-05-30T20:26:46.903Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'workflow-diagram',
              description: null,
              file: {
                url: '/img/contentful/3yz6FE0k-workflow-diagram.svg',
                details: {
                  size: 152828,
                  image: {
                    width: 520,
                    height: 440
                  }
                },
                fileName: 'workflow-diagram.svg',
                contentType: 'image/svg+xml'
              }
            }
          }
        }
      }
    ],
    webinarSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '1QHJRnxFxXmToAn5Eb4pj0',
        type: 'Entry',
        createdAt: '2024-05-29T21:35:09.881Z',
        updatedAt: '2024-05-29T21:35:09.881Z',
        environment: null,
        publishedVersion: 5,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title:
          'See how Flatfile streamlines data imports for faster customer onboarding',
        topHatText: 'WEBINAR',
        heading:
          'See how Flatfile streamlines data imports for faster customer onboarding',
        intro:
          'Field service teams are reclaiming their time by utilizing data exchange platforms like Flatfile to accelerate and simplify importing CSV files, Excel spreadsheets and many other file types from internal and external sources.',
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '1JrHc3Y297fOvZXeVjdJMH',
              type: 'Entry',
              createdAt: '2024-05-29T21:34:22.278Z',
              updatedAt: '2024-05-29T21:34:22.278Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Get a personalized demo',
              buttonText: 'Get a personalized demo',
              buttonUrl: '/contact-sales/consult/',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ],
        video: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '6u2NlOeDWb3oQrJdBimlbh',
            type: 'Entry',
            createdAt: '2024-04-25T14:02:34.554Z',
            updatedAt: '2024-04-25T14:02:34.554Z',
            environment: null,
            publishedVersion: 2,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            title: 'Field Services',
            video: {
              items: [
                {
                  hashed_id: '94rr5br3he',
                  id: 118466398,
                  duration: 1830.08,
                  thumbnail: {
                    url: 'https://embed-ssl.wistia.com/deliveries/327aef979ec7e439a4323bdbaa2bd50f.jpg?image_crop_resized=200x120',
                    width: 200,
                    height: 120
                  }
                }
              ]
            }
          }
        }
      }
    },
    guidedBlocksSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '1jPaZsKx5T3RAeCZq3xE2i',
        type: 'Entry',
        createdAt: '2024-05-29T21:36:15.824Z',
        updatedAt: '2024-06-07T16:59:55.009Z',
        environment: null,
        publishedVersion: 11,
        revision: 4,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        internalName: 'Getting started is easy (field services)',
        topHatText: "LET'S TALK",
        title: 'Getting started is easy',
        cards: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2xlg2q0Z9qvGdeCEzODl1A',
              type: 'Entry',
              createdAt: '2024-05-29T21:39:05.724Z',
              updatedAt: '2024-05-29T21:39:05.724Z',
              environment: null,
              publishedVersion: 9,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Connect (field services)',
              title: 'Connect',
              bodyText:
                'Learn how Flatfile transforms data onboarding as you know it',
              linkText: 'Connect with us',
              linkUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=field-services'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3fRYoJeOMCYXsP22b4SnaK',
              type: 'Entry',
              createdAt: '2024-05-29T21:39:58.644Z',
              updatedAt: '2024-05-29T21:39:58.644Z',
              environment: null,
              publishedVersion: 7,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Demo (field services)',
              title: 'Demo',
              bodyText: 'See how field service companies are using Flatfile',
              linkText: 'Check it out',
              linkUrl: '/resources/webinars/field-service-to-system-ready-data/'
            }
          }
        ]
      }
    },
    platformOverviewHeading: 'Meet the Flatfile Data Exchange Platform',
    platformOverviewFeatures: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4PY0isKBdPxOCChfUh8K7m',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:07.060Z',
          updatedAt: '2024-05-29T21:04:07.060Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Built for developers',
          intro:
            'Flatfile’s robust API, SDKs and code-based approach provide true flexibility and control, unlike low-code solutions. Seamlessly integrates into your existing infrastructure with Git-based configuration and source control.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '6Teayyzp67P0UYw9mK1VHv',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:29.399Z',
          updatedAt: '2024-05-29T21:04:29.399Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Intuitive for end users',
          intro:
            'The familiar spreadsheet-style interface highlights errors and streamlines tasks like search, find, replace and sort. It ensures a seamless experience with fully customizable workflows and theming to align perfectly with your process and brand.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '3NbyYdglQbzTy3cN2D62p5',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:52.494Z',
          updatedAt: '2024-05-29T21:04:52.494Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Everything needed for file import',
          intro:
            'The industry’s most comprehensive data import experience at your fingertips, fully extensible with your own code. Import any data file type from any source. Clean data inconsistencies and formatting issues automatically.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5VSNemQ5JAxPbh1GIr0mZ7',
          type: 'Entry',
          createdAt: '2024-05-29T21:05:12.571Z',
          updatedAt: '2024-05-29T21:05:12.571Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Enterprise scale',
          intro:
            'Scalable and secure by default, Flatfile was built to meet rigorous enterprise security and compliance standards and provide the robust infrastructure necessary for large- scale data operations.'
        }
      }
    ],
    customerQuoteSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '4Kg0ZuiQl4wecxvjilDFv1',
        type: 'Entry',
        createdAt: '2024-05-29T21:11:15.028Z',
        updatedAt: '2024-05-29T21:11:15.028Z',
        environment: null,
        publishedVersion: 6,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Buildops Quote',
        theme: true,
        body: 'It’s one of the more important tools in our implementation toolbox. Without tools like Flatfile, scaling would be almost impossible.',
        quotee: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: 'uPXeGizgWEZvwU5GT520q',
            type: 'Entry',
            createdAt: '2024-05-29T21:08:42.768Z',
            updatedAt: '2024-05-29T21:08:42.768Z',
            environment: null,
            publishedVersion: 5,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            fullName: ' Scott Patterson',
            headshot: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '683Iy5HG9J0IIX6mLsjhrU',
                type: 'Asset',
                createdAt: '2024-05-29T21:08:11.296Z',
                updatedAt: '2024-05-29T21:08:11.296Z',
                environment: null,
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'workday-photo',
                description: null,
                file: {
                  url: '/img/contentful/683Iy5HG-workday-photo.webp',
                  details: {
                    size: 960220,
                    image: {
                      width: 961,
                      height: 960
                    }
                  },
                  fileName: 'workday-photo.png',
                  contentType: 'image/png'
                }
              }
            },
            jobTitle: 'Director of Implementation',
            company: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '6mV1CXFczPDzORxRwEhTTM',
                type: 'Entry',
                createdAt: '2024-01-02T22:09:30.412Z',
                updatedAt: '2025-04-08T22:31:49.207Z',
                environment: null,
                publishedVersion: 24,
                revision: 6,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                name: 'BuildOps',
                logo: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '6Ys8olKZa4ZocR2sxpahr2',
                    type: 'Asset',
                    createdAt: '2024-01-03T17:35:23.409Z',
                    updatedAt: '2024-01-03T18:09:04.577Z',
                    environment: null,
                    publishedVersion: 15,
                    revision: 2,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'BuildOps_logo',
                    description: 'BuildOps logo',
                    file: {
                      url: '/img/contentful/6Ys8olKZ-buildops_logo_final.webp',
                      details: {
                        size: 70470,
                        image: {
                          width: 1629,
                          height: 258
                        }
                      },
                      fileName: 'BuildOps_Logo_final.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                logoBlack: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '1NKL9mMoLhx7nSwAZaTSKe',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.128Z',
                    updatedAt: '2024-04-29T20:24:29.128Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'buildops',
                    file: {
                      url: '/img/contentful/1NKL9mMo-buildops.webp',
                      details: {
                        size: 10706,
                        image: {
                          width: 280,
                          height: 56
                        }
                      },
                      fileName: 'buildops.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoWhite: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '1NKL9mMoLhx7nSwAZaTSKe',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.128Z',
                    updatedAt: '2024-04-29T20:24:29.128Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'buildops',
                    file: {
                      url: '/img/contentful/1NKL9mMo-buildops.webp',
                      details: {
                        size: 10706,
                        image: {
                          width: 280,
                          height: 56
                        }
                      },
                      fileName: 'buildops.png',
                      contentType: 'image/png'
                    }
                  }
                },
                coverPhoto: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '3WAtTZSZa1HuLu6aClnoTg',
                    type: 'Asset',
                    createdAt: '2024-01-03T20:03:13.745Z',
                    updatedAt: '2024-01-03T20:03:13.745Z',
                    environment: null,
                    publishedVersion: 3,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'danist-soh-8Gg2Ne uTcM-unsplash',
                    description: null,
                    file: {
                      url: '/img/contentful/3WAtTZSZ-danist-soh-8gg2ne_utcm-unsplash.webp',
                      details: {
                        size: 2885032,
                        image: {
                          width: 4808,
                          height: 3205
                        }
                      },
                      fileName: 'danist-soh-8Gg2Ne_uTcM-unsplash.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                location: 'San Francisco, California ',
                industry: 'Field service management software',
                department: ['Support', 'Sales'],
                keyFeaturesUsed: ['AI apps', 'Knowledge Graph', 'Style Guide'],
                website: 'buildops.com'
              }
            }
          }
        },
        photo: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '683Iy5HG9J0IIX6mLsjhrU',
            type: 'Asset',
            createdAt: '2024-05-29T21:08:11.296Z',
            updatedAt: '2024-05-29T21:08:11.296Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'workday-photo',
            description: null,
            file: {
              url: '/img/contentful/683Iy5HG-workday-photo.webp',
              details: {
                size: 960220,
                image: {
                  width: 961,
                  height: 960
                }
              },
              fileName: 'workday-photo.png',
              contentType: 'image/png'
            }
          }
        },
        ctaLink: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '4DY7xQys161myJxi2mp6sO',
            type: 'Entry',
            createdAt: '2024-05-29T21:11:02.926Z',
            updatedAt: '2024-06-14T17:20:14.301Z',
            environment: null,
            publishedVersion: 7,
            revision: 3,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            title:
              'Learn more about how BuildOps decreased customer activation time by 20% with Flatfile',
            linkText:
              'Learn more about how BuildOps decreased customer activation time by 20% with Flatfile',
            linkUrl:
              '/resources/case-studies/buildops-clears-data-import-bottleneck-with-flatfile/'
          }
        }
      }
    },
    showWayfinder: true
  },
  {
    id: '6uju6zhE0XmU3uCxVrd1BU',
    contentful_id: '6uju6zhE0XmU3uCxVrd1BU',
    createdAt: '2024-06-07T20:47:45.513Z',
    updatedAt: '2024-06-07T22:31:04.991Z',
    __typename: 'verticalLandingPage',
    internalTitle: 'marketplaces',
    urlSlug: 'marketplaces',
    hidePage: null,
    seo: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5lqLq1V1NOi9FMUGrwUb79',
        type: 'Entry',
        createdAt: '2024-06-07T16:41:08.004Z',
        updatedAt: '2024-06-07T17:22:20.957Z',
        environment: null,
        publishedVersion: 10,
        revision: 3,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Onboard merchant data faster',
        description:
          'Convert and onboard your merchant data with ease so that you get products live faster and at lower cost, regardless of variable formatting or structure.'
      }
    },
    hero: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '6nDyDcX1DLHfJ9f20io0eE',
        type: 'Entry',
        createdAt: '2024-06-07T17:13:20.129Z',
        updatedAt: '2024-06-07T17:13:20.129Z',
        environment: null,
        publishedVersion: 11,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Marketplaces hero',
        topHatText: 'FLATFILE FOR ONLINE MARKETPLACES',
        heading: 'Get merchant data, faster',
        bodyText:
          'Flatfile’s AI-assisted data exchange platform is ideal for online marketplaces. Convert and onboard your merchant data with ease so that you get products live faster and at lower cost, regardless of variable formatting or structure.',
        ctaButtons: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3MuyFhF65nxVOUHqVfxMU8',
              type: 'Entry',
              createdAt: '2024-06-07T16:43:20.784Z',
              updatedAt: '2024-06-07T16:43:20.784Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Connect with an expert (marketplaces)',
              buttonText: 'Connect with an expert',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=marketplaces',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7uT1LOJV6ksVQtOxV9VPeX',
              type: 'Entry',
              createdAt: '2024-06-07T16:44:27.532Z',
              updatedAt: '2024-06-07T16:44:27.532Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'See how it works (marketplaces)',
              buttonText: 'See how it works',
              buttonUrl:
                '/demo/?engagement_context_type=gtm-vertical-referral&engagement_context_value=marketplaces',
              onPageAnchor: null,
              buttonStyle: 'Secondary'
            }
          }
        ],
        image: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '6Xh8gqs0TXETHEUo2kv7xO',
            type: 'Asset',
            createdAt: '2024-06-07T16:45:40.085Z',
            updatedAt: '2024-06-07T16:45:40.085Z',
            environment: null,
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'marketplaces-hero',
            description: null,
            file: {
              url: '/img/contentful/6Xh8gqs0-marketplaces-hero.webp',
              details: {
                size: 246705,
                image: {
                  width: 3178,
                  height: 1504
                }
              },
              fileName: 'marketplaces-hero.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    logoBanner: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '1ZywvCAo75epltwjoPTPg3',
        type: 'Entry',
        createdAt: '2024-06-07T16:47:27.777Z',
        updatedAt: '2024-06-07T16:47:27.777Z',
        environment: null,
        publishedVersion: 9,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        name: 'marketplaces logo bar',
        title: 'TRUSTED BY THE WORLD’S LEADING PRODUCT ENABLED ORGANIZATIONS',
        logos: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4bPeHF7nZ6i6aTQhKHhL4S',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.192Z',
              updatedAt: '2024-04-29T20:24:29.192Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'pernodricard',
              file: {
                url: '/img/contentful/4bPeHF7n-pernodricard.webp',
                details: {
                  size: 2488,
                  image: {
                    width: 166,
                    height: 64
                  }
                },
                fileName: 'pernodricard.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4tecqedQxYRwGniOcfTlz9',
              type: 'Asset',
              createdAt: '2021-10-21T19:55:38.140Z',
              updatedAt: '2021-10-21T19:55:38.140Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Square color logo',
              description: 'Square color logo',
              file: {
                url: '/img/contentful/4tecqedQ-square.svg',
                details: {
                  size: 4968,
                  image: {
                    width: 160,
                    height: 40
                  }
                },
                fileName: 'square.svg',
                contentType: 'image/svg+xml'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6tibPF8t6UjL1bXR0yfnIn',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.218Z',
              updatedAt: '2024-04-29T20:24:29.218Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'whitepages',
              file: {
                url: '/img/contentful/6tibPF8t-whitepages.webp',
                details: {
                  size: 3370,
                  image: {
                    width: 264,
                    height: 64
                  }
                },
                fileName: 'whitepages.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2wM82eVHsLutWpxKvPkz2n',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.152Z',
              updatedAt: '2024-04-29T20:24:29.152Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'wineshipping',
              file: {
                url: '/img/contentful/2wM82eVH-wineshipping.webp',
                details: {
                  size: 3658,
                  image: {
                    width: 400,
                    height: 80
                  }
                },
                fileName: 'wineshipping.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '71QPLIFEbqIzGidcZMxUZ5',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.224Z',
              updatedAt: '2024-04-29T20:24:29.224Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'toast',
              file: {
                url: '/img/contentful/71QPLIFE-toast.webp',
                details: {
                  size: 2877,
                  image: {
                    width: 242,
                    height: 64
                  }
                },
                fileName: 'toast.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '1k8VRqZNcajAALIrr2bAna',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.124Z',
              updatedAt: '2024-04-29T20:24:29.124Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'beautybay',
              file: {
                url: '/img/contentful/1k8VRqZN-beautybay.webp',
                details: {
                  size: 2478,
                  image: {
                    width: 136,
                    height: 64
                  }
                },
                fileName: 'beautybay.png',
                contentType: 'image/png'
              }
            }
          }
        ],
        theme: 'Light'
      }
    },
    twoThirdsSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5cOtg2UK2qDQiqlGn36El4',
        type: 'Entry',
        createdAt: '2024-06-07T16:50:25.960Z',
        updatedAt: '2024-06-07T16:50:25.960Z',
        environment: null,
        publishedVersion: 9,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title:
          'Do these common merchant onboarding problems sound familiar? (marketplaces)',
        topHatText: 'DON’T COMPROMISE',
        heading:
          'Do these common merchant onboarding problems sound familiar? ',
        checklist: [
          'Hours and resources wasted on  redundant data onboarding tasks',
          'Merchant friction caused by complicated or slow onboarding processes',
          'Delayed stakeholder activation caused by rigid workflows',
          'Complex and non-standard data with borderless ecommerce'
        ],
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2yM2OgkTjH7fYOrvNcGE6E',
              type: 'Entry',
              createdAt: '2024-06-07T16:50:18.188Z',
              updatedAt: '2024-06-07T20:49:50.806Z',
              environment: null,
              publishedVersion: 9,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Learn how Flatfile can help (marketplaces)',
              buttonText: 'Learn how Flatfile can help',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=marketplaces',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ]
      }
    },
    timedCarouselHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '1WfpwAMMXd9m6HccVVFxYf',
        type: 'Entry',
        createdAt: '2024-06-07T16:50:56.394Z',
        updatedAt: '2024-06-07T16:50:56.394Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle:
          'No more costly, services-heavy data conversion processes (marketplaces)',
        heading: 'No more costly, services-heavy data conversion processes',
        bodyText:
          "If you have merchants you’re onboarding, loading your platform with product data is a necessary first step before a merchant will get any value from being on your online marketplace. Any delay or complication in getting their data into your system will affect your merchant's ROI and can impact your revenue."
      }
    },
    timedCarouselItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '3vBDk8jwRRPLa4rk91dWtS',
          type: 'Entry',
          createdAt: '2024-06-07T16:51:22.912Z',
          updatedAt: '2024-06-27T19:51:23.404Z',
          environment: null,
          publishedVersion: 7,
          revision: 3,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Accelerate time-to-value (marketplaces)',
          heading: 'Accelerate time-to-value',
          intro:
            'Get merchant data into your systems faster with the data mapping and import experience your business needs -- without delay or compromises.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7eryG6k4KY2yEEqhBXP2Wq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:17.532Z',
              updatedAt: '2024-06-27T19:24:17.532Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'accelerate time to value',
              description: null,
              file: {
                url: '/img/contentful/7eryG6k4-accelerate_time_to_value.webp',
                details: {
                  size: 15901,
                  image: {
                    width: 801,
                    height: 406
                  }
                },
                fileName: 'Accelerate Time to Value.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4F9zoyImMF5UgJZBAMFJKl',
          type: 'Entry',
          createdAt: '2024-06-07T16:53:01.120Z',
          updatedAt: '2024-06-27T19:51:32.217Z',
          environment: null,
          publishedVersion: 6,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title:
            'Minimize in-house services & development costs (marketplaces)',
          heading: 'Minimize in-house services & development costs',
          intro:
            'Keep limited and expensive engineering resources focused on your unique business differentiators without the distraction, cost and time it takes to build data import functionality.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: 'SlNCDNMdLILgoJ0tg2Gvq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:45.736Z',
              updatedAt: '2024-06-27T19:24:45.736Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Minimize in-house costs',
              description: null,
              file: {
                url: '/img/contentful/SlNCDNMd-minimize_inhouse_costs.webp',
                details: {
                  size: 16038,
                  image: {
                    width: 818,
                    height: 439
                  }
                },
                fileName: 'Minimize inhouse costs.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: 'vUgqYj0FJiO5LrNVSOFjt',
          type: 'Entry',
          createdAt: '2024-06-07T16:54:32.384Z',
          updatedAt: '2024-06-27T19:52:20.562Z',
          environment: null,
          publishedVersion: 7,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Reduce data errors, increase data quality (marketplaces)',
          heading: 'Reduce data errors, increase data quality',
          intro:
            "Make sure the data entered into your database is consistent, clean and validated. This will reduce onboarding delays and, more importantly, the likelihood that you'll make incorrect decisions based on bad data.",
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2tlUqPKcZwQSpelyGsQy3X',
              type: 'Asset',
              createdAt: '2024-06-27T19:25:13.124Z',
              updatedAt: '2024-06-27T19:25:13.124Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Reduce data errors',
              description: null,
              file: {
                url: '/img/contentful/2tlUqPKc-reduce_data_errors.webp',
                details: {
                  size: 13842,
                  image: {
                    width: 814,
                    height: 395
                  }
                },
                fileName: 'Reduce data errors.png',
                contentType: 'image/png'
              }
            }
          }
        }
      }
    ],
    waterfallSectionHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '4LoY90xmNbrweEodCZaJyz',
        type: 'Entry',
        createdAt: '2024-06-07T16:55:08.675Z',
        updatedAt: '2024-06-07T16:55:08.675Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Seamless data onboarding with Flatfile (marketplaces)',
        heading: 'Seamless data onboarding with Flatfile',
        bodyText:
          'The Flatfile Data Exchange Platform provides all the tools your merchants and your implementation teams need for a seamless data onboarding experience.'
      }
    },
    waterfallSectionItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5lsCvpuxZFHkcj7Z3GgS2u',
          type: 'Entry',
          createdAt: '2024-06-07T16:56:30.822Z',
          updatedAt: '2024-06-07T16:56:39.058Z',
          environment: null,
          publishedVersion: 6,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Automate tasks with AI-enhanced mapping (marketplaces)',
          heading: 'Automate tasks with AI-enhanced mapping',
          intro:
            'Stop sending Excel files back-and-forth via email. Flatfile’s AI powered source to target mapping auto-magically converts merchant data into your desired format. Automated validations, transformations and workflows ensure data is squeaky clean, approved and ready for production -- faster.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3ZAouVb8yMECmFTlNTBApb',
              type: 'Asset',
              createdAt: '2024-05-30T20:25:34.299Z',
              updatedAt: '2024-05-30T20:25:34.299Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'visual-diff',
              description: null,
              file: {
                url: '/img/contentful/3ZAouVb8-visual-diff.webp',
                details: {
                  size: 35605,
                  image: {
                    width: 1120,
                    height: 598
                  }
                },
                fileName: 'visual-diff.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '1VE4twfqHxldeGQzfvymjf',
          type: 'Entry',
          createdAt: '2024-06-07T16:57:37.409Z',
          updatedAt: '2024-06-07T16:57:37.409Z',
          environment: null,
          publishedVersion: 4,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Collaborate on data your way (marketplaces)',
          heading: 'Collaborate on data your way',
          intro:
            'Streamline complex data workflows across diverse stakeholders. Onboard new merchants or solve any collaborative need for importing, validating, editing and approving data. Granular access control and powerful data transformations ensure the right people manage the right data at the right time.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3svuVeJmsgDyo1g6kBVM6u',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:14.090Z',
              updatedAt: '2024-05-30T20:26:14.090Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'hcm-collab-img',
              description: null,
              file: {
                url: '/img/contentful/3svuVeJm-hcm-collab-img.webp',
                details: {
                  size: 56151,
                  image: {
                    width: 1164,
                    height: 782
                  }
                },
                fileName: 'hcm-collab-img.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4mAPxbFz3WZ8cJkvkpJDQo',
          type: 'Entry',
          createdAt: '2024-06-07T16:58:16.249Z',
          updatedAt: '2024-06-07T16:58:16.249Z',
          environment: null,
          publishedVersion: 5,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Tailored workflows for varying data needs (marketplaces)',
          heading: 'Tailored workflows for varying data needs',
          intro:
            'merchants bring highly unstructured and variable data that needs to be imported, validated, transformed and cleaned. Flatfile’s robust and extensible SDKs, APIs and plugins enable you to easily cater to and personalize your workflows and schemas to a customers needs -- without the added effort.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3yz6FE0kOiwhEMMHf5aBVV',
              type: 'Asset',
              createdAt: '2024-05-30T20:26:46.903Z',
              updatedAt: '2024-05-30T20:26:46.903Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'workflow-diagram',
              description: null,
              file: {
                url: '/img/contentful/3yz6FE0k-workflow-diagram.svg',
                details: {
                  size: 152828,
                  image: {
                    width: 520,
                    height: 440
                  }
                },
                fileName: 'workflow-diagram.svg',
                contentType: 'image/svg+xml'
              }
            }
          }
        }
      }
    ],
    webinarSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5BiKpw3BlEgUNjyzNFcwWF',
        type: 'Entry',
        createdAt: '2024-06-07T16:59:34.510Z',
        updatedAt: '2024-06-07T16:59:34.510Z',
        environment: null,
        publishedVersion: 5,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title:
          'See how Flatfile fast-tracks data file import for your suppliers (marketplaces)',
        heading:
          'See how Flatfile fast-tracks data file import for your suppliers',
        intro:
          'Online marketplaces are reclaiming their time by utilizing data exchange platforms like Flatfile to deal with unstructured or variable data from thousands of suppliers.',
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '1vuw1UJMTglpO4D4aOvqRf',
              type: 'Entry',
              createdAt: '2024-06-07T16:59:30.458Z',
              updatedAt: '2024-06-07T16:59:30.458Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Get a personalized demo (marketplaces)',
              buttonText: 'Get a personalized demo',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=marketplaces',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ],
        video: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '3A7sw1hy5Xl6z4ooWxbOQj',
            type: 'Entry',
            createdAt: '2024-04-24T18:55:58.899Z',
            updatedAt: '2024-06-07T18:14:23.416Z',
            environment: null,
            publishedVersion: 7,
            revision: 2,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            title:
              "How to fast-track data file import for your marketplace's suppliers",
            video: {
              items: [
                {
                  hashed_id: 'h0kerli87k',
                  id: 118449280,
                  duration: 2643.61,
                  thumbnail: {
                    url: 'https://embed-ssl.wistia.com/deliveries/46245cbacac76f802a944bdb0b07f995.jpg?image_crop_resized=200x120',
                    width: 200,
                    height: 120
                  }
                }
              ]
            }
          }
        }
      }
    },
    guidedBlocksSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '4HdDaNmheGUIm7pRVvYc6r',
        type: 'Entry',
        createdAt: '2024-06-07T17:03:28.791Z',
        updatedAt: '2024-06-07T17:03:28.791Z',
        environment: null,
        publishedVersion: 5,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        internalName: 'Getting started is easy (marketplaces)',
        topHatText: "LET'S TALK",
        title: 'Getting started is easy',
        cards: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '4rF3YztoHrpmyv2TnVW5OE',
              type: 'Entry',
              createdAt: '2024-06-07T17:02:46.395Z',
              updatedAt: '2024-06-07T17:02:46.395Z',
              environment: null,
              publishedVersion: 7,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Connect (marketplaces)',
              title: 'Connect',
              bodyText:
                'Learn how Flatfile transforms data onboarding as you know it',
              linkText: 'Connect with us',
              linkUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=marketplaces'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3rYO0v9JXmEEVOQGON1Tvm',
              type: 'Entry',
              createdAt: '2024-06-07T17:03:25.694Z',
              updatedAt: '2024-06-07T17:03:25.694Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Demo (marketplaces)',
              title: 'Demo',
              bodyText: 'See how online marketplaces are using Flatfile',
              linkText: 'Check it out',
              linkUrl:
                '/resources/webinars/data-file-import-for-marketplaces-suppliers/'
            }
          }
        ]
      }
    },
    platformOverviewHeading: 'Meet the Flatfile Data Exchange Platform',
    platformOverviewFeatures: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4PY0isKBdPxOCChfUh8K7m',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:07.060Z',
          updatedAt: '2024-05-29T21:04:07.060Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Built for developers',
          intro:
            'Flatfile’s robust API, SDKs and code-based approach provide true flexibility and control, unlike low-code solutions. Seamlessly integrates into your existing infrastructure with Git-based configuration and source control.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '6Teayyzp67P0UYw9mK1VHv',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:29.399Z',
          updatedAt: '2024-05-29T21:04:29.399Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Intuitive for end users',
          intro:
            'The familiar spreadsheet-style interface highlights errors and streamlines tasks like search, find, replace and sort. It ensures a seamless experience with fully customizable workflows and theming to align perfectly with your process and brand.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '3NbyYdglQbzTy3cN2D62p5',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:52.494Z',
          updatedAt: '2024-05-29T21:04:52.494Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Everything needed for file import',
          intro:
            'The industry’s most comprehensive data import experience at your fingertips, fully extensible with your own code. Import any data file type from any source. Clean data inconsistencies and formatting issues automatically.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5VSNemQ5JAxPbh1GIr0mZ7',
          type: 'Entry',
          createdAt: '2024-05-29T21:05:12.571Z',
          updatedAt: '2024-05-29T21:05:12.571Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Enterprise scale',
          intro:
            'Scalable and secure by default, Flatfile was built to meet rigorous enterprise security and compliance standards and provide the robust infrastructure necessary for large- scale data operations.'
        }
      }
    ],
    customerQuoteSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '17sdmZY0QlfPLKkzyINO5h',
        type: 'Entry',
        createdAt: '2024-06-07T17:04:42.857Z',
        updatedAt: '2024-06-07T20:50:40.870Z',
        environment: null,
        publishedVersion: 11,
        revision: 3,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'mimeo quote',
        theme: true,
        body: 'We have always handled our data import internally. But this time, we needed to do it faster and with the assurance that it would be done without errors and securely.',
        quotee: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '4JC8IWWb70KY99CYoBNPRm',
            type: 'Entry',
            createdAt: '2024-06-07T17:38:02.061Z',
            updatedAt: '2024-06-07T17:38:02.061Z',
            environment: null,
            publishedVersion: 5,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            fullName: 'Heath Cajandig',
            headshot: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '683Iy5HG9J0IIX6mLsjhrU',
                type: 'Asset',
                createdAt: '2024-05-29T21:08:11.296Z',
                updatedAt: '2024-05-29T21:08:11.296Z',
                environment: null,
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'workday-photo',
                description: null,
                file: {
                  url: '/img/contentful/683Iy5HG-workday-photo.webp',
                  details: {
                    size: 960220,
                    image: {
                      width: 961,
                      height: 960
                    }
                  },
                  fileName: 'workday-photo.png',
                  contentType: 'image/png'
                }
              }
            },
            jobTitle: 'Vice President of Product',
            company: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: 'eiYOrx8Cweua49ynG56A3',
                type: 'Entry',
                createdAt: '2023-01-17T23:42:05.546Z',
                updatedAt: '2024-05-07T16:55:15.951Z',
                environment: null,
                publishedVersion: 12,
                revision: 3,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                name: 'Mimeo',
                logo: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '5FySJ0HYBUfI6hzAcdV5O4',
                    type: 'Asset',
                    createdAt: '2023-01-25T17:08:22.137Z',
                    updatedAt: '2023-01-25T17:08:22.137Z',
                    environment: null,
                    publishedVersion: 4,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'Mimeo Logo',
                    description: null,
                    file: {
                      url: '/img/contentful/5FySJ0HY-mimeo.webp',
                      details: {
                        size: 1992,
                        image: {
                          width: 186,
                          height: 48
                        }
                      },
                      fileName: 'Mimeo.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoBlack: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '6X2HKpvRrokkeccqwq0vE9',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.220Z',
                    updatedAt: '2024-04-29T20:24:29.220Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'mimeo',
                    file: {
                      url: '/img/contentful/6X2HKpvR-mimeo.webp',
                      details: {
                        size: 1976,
                        image: {
                          width: 224,
                          height: 56
                        }
                      },
                      fileName: 'mimeo.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoWhite: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '1ETtHn59rKHUFVZtrj285Q',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.122Z',
                    updatedAt: '2024-04-29T20:24:29.122Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'mimeo-white',
                    file: {
                      url: '/img/contentful/1ETtHn59-mimeo-white.webp',
                      details: {
                        size: 2066,
                        image: {
                          width: 224,
                          height: 56
                        }
                      },
                      fileName: 'mimeo-white.png',
                      contentType: 'image/png'
                    }
                  }
                },
                coverPhoto: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '1vur5qwBd8Y1JgrDbRBamg',
                    type: 'Asset',
                    createdAt: '2023-01-17T23:40:57.397Z',
                    updatedAt: '2023-01-17T23:40:57.397Z',
                    environment: null,
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'Printing image ',
                    description: null,
                    file: {
                      url: '/img/contentful/1vur5qwB-bank-phrom-tzm3oyu_6sk-unsplash.webp',
                      details: {
                        size: 2025514,
                        image: {
                          width: 6016,
                          height: 4016
                        }
                      },
                      fileName: 'bank-phrom-Tzm3Oyu_6sk-unsplash.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                industry: 'Printing Services',
                website: 'mimeo.com'
              }
            }
          }
        },
        photo: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '683Iy5HG9J0IIX6mLsjhrU',
            type: 'Asset',
            createdAt: '2024-05-29T21:08:11.296Z',
            updatedAt: '2024-05-29T21:08:11.296Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'workday-photo',
            description: null,
            file: {
              url: '/img/contentful/683Iy5HG-workday-photo.webp',
              details: {
                size: 960220,
                image: {
                  width: 961,
                  height: 960
                }
              },
              fileName: 'workday-photo.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    showWayfinder: true
  },
  {
    id: '5DFxi5M529dA6FuB7WxGYW',
    contentful_id: '5DFxi5M529dA6FuB7WxGYW',
    createdAt: '2024-05-29T23:27:47.226Z',
    updatedAt: '2024-06-07T19:34:08.391Z',
    __typename: 'verticalLandingPage',
    internalTitle: 'Test Landing Page',
    urlSlug: 'test-landing-page',
    hidePage: true,
    seo: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '1ezHZPPIkiAuYRduGEWiJG',
        type: 'Entry',
        createdAt: '2024-05-22T19:05:03.227Z',
        updatedAt: '2024-05-22T19:06:39.585Z',
        environment: null,
        publishedVersion: 13,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'How Flatfile helped Galley achieve 10X ROI',
        description:
          'Find out how Flatfile helped Galley tackle complex data import requirements and achieve 10X ROI.',
        image: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '53ka0TzyGDOizXnIrhTFTp',
            type: 'Asset',
            createdAt: '2024-05-22T18:36:21.780Z',
            updatedAt: '2024-05-23T16:13:36.384Z',
            environment: null,
            publishedVersion: 8,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Galley-logo',
            description: 'Galley logo',
            file: {
              url: '/img/contentful/53ka0Tzy-galley-logo-landscape.webp',
              details: {
                size: 89969,
                image: {
                  width: 1089,
                  height: 271
                }
              },
              fileName: 'Galley-logo-landscape.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    hero: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '15AIdGdZSVNBEjB5Y9LBIt',
        type: 'Entry',
        createdAt: '2024-05-29T21:15:39.564Z',
        updatedAt: '2024-05-30T20:10:57.321Z',
        environment: null,
        publishedVersion: 14,
        revision: 4,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Field Services hero',
        topHatText: 'FLATFILE FOR FIELD SERVICE MANAGEMENT (FSM) SOFTWARE',
        heading: 'Customer data migration, simplified',
        bodyText:
          'Flatfile’s AI-assisted data exchange platform is ideal for Field Service Management (FSM) software. Convert and migrate your customer’s data with ease so that you get them live faster, at lower cost and with full confidence in data quality.',
        ctaButtons: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6Fkfw0iPKgUjWC93uvSooa',
              type: 'Entry',
              createdAt: '2024-05-29T21:14:35.020Z',
              updatedAt: '2024-05-30T19:44:45.793Z',
              environment: null,
              publishedVersion: 8,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Connect with an expert (field services)',
              buttonText: 'Connect with an expert',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=field-services',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3wSO6Vxkx951F3BZfHkQNa',
              type: 'Entry',
              createdAt: '2024-05-29T21:15:14.354Z',
              updatedAt: '2024-06-06T18:07:01.898Z',
              environment: null,
              publishedVersion: 6,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'See how it works (on page anchor)',
              buttonText: 'See how it works',
              buttonUrl: '#videoBlock',
              onPageAnchor: true,
              buttonStyle: 'Secondary'
            }
          }
        ],
        image: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '7vURYSitblRXJPj7OQtLdX',
            type: 'Asset',
            createdAt: '2024-05-30T20:10:46.918Z',
            updatedAt: '2024-05-30T20:10:46.918Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'fieldops-hero',
            description: null,
            file: {
              url: '/img/contentful/7vURYSit-fieldops-hero.avif.webp',
              details: {
                size: 52829,
                image: {
                  width: 1577,
                  height: 746
                }
              },
              fileName: 'fieldops-hero.avif',
              contentType: 'image/avif'
            }
          }
        }
      }
    },
    logoBanner: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5uHOx3QJ3lJELmk12AQeTK',
        type: 'Entry',
        createdAt: '2021-10-21T20:03:24.380Z',
        updatedAt: '2024-06-06T18:20:33.756Z',
        environment: null,
        publishedVersion: 27,
        revision: 7,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        name: 'Default logo banner',
        title:
          'HUNDREDS OF BUSINESSES TURN FILES INTO API-READY DATA WITH FLATFILE',
        logos: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5A8fk63Or8Yj5mtcQLBS2q',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.200Z',
              updatedAt: '2024-04-29T20:24:29.200Z',
              environment: null,
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'adp',
              file: {
                url: '/img/contentful/5A8fk63O-adp.webp',
                details: {
                  size: 1789,
                  image: {
                    width: 122,
                    height: 80
                  }
                },
                fileName: 'adp.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3WYIAgYYoXS7eadLxhkBVK',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.191Z',
              updatedAt: '2024-04-29T20:24:29.191Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'servicetitan',
              file: {
                url: '/img/contentful/3WYIAgYY-servicetitan.webp',
                details: {
                  size: 5183,
                  image: {
                    width: 376,
                    height: 64
                  }
                },
                fileName: 'servicetitan.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5q2FVdSvVsOcUupw0CNZXA',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.210Z',
              updatedAt: '2024-04-29T20:24:29.210Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'square',
              file: {
                url: '/img/contentful/5q2FVdSv-square.webp',
                details: {
                  size: 2659,
                  image: {
                    width: 256,
                    height: 64
                  }
                },
                fileName: 'square.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5eUFEdx4taKxhWrbnOj5Eg',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.206Z',
              updatedAt: '2024-04-29T20:24:29.206Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'clickup',
              file: {
                url: '/img/contentful/5eUFEdx4-clickup.webp',
                details: {
                  size: 2915,
                  image: {
                    width: 268,
                    height: 64
                  }
                },
                fileName: 'clickup.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3AbQnlMPkqHu3tI85QrjIP',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.157Z',
              updatedAt: '2024-04-29T20:24:29.157Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'astrazeneca',
              file: {
                url: '/img/contentful/3AbQnlMP-astrazeneca.webp',
                details: {
                  size: 4017,
                  image: {
                    width: 356,
                    height: 48
                  }
                },
                fileName: 'astrazeneca.png',
                contentType: 'image/png'
              }
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '3mQPrtyZEMCi8485UT83bi',
              type: 'Asset',
              createdAt: '2024-04-29T20:24:29.161Z',
              updatedAt: '2024-04-29T20:24:29.161Z',
              environment: null,
              publishedVersion: 2,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'sage',
              file: {
                url: '/img/contentful/3mQPrtyZ-sage.webp',
                details: {
                  size: 2025,
                  image: {
                    width: 148,
                    height: 56
                  }
                },
                fileName: 'sage.png',
                contentType: 'image/png'
              }
            }
          }
        ],
        theme: 'Light'
      }
    },
    twoThirdsSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '7fFPEEXN14u2hmC4MQSk3',
        type: 'Entry',
        createdAt: '2024-05-29T21:19:42.155Z',
        updatedAt: '2024-05-30T20:13:19.202Z',
        environment: null,
        publishedVersion: 9,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Do these common data migration problems sound familiar?',
        topHatText: 'DON’T COMPROMISE',
        heading: 'Do these common data migration problems sound familiar?',
        checklist: [
          'Hours and resources wasted on redundant data migration tasks',
          'Customer friction caused by complicated data onboarding processes',
          'Delayed customer activation caused by rigid and manual workflows',
          'Decreased bandwidth due to slow implementation speeds'
        ],
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6ztXsUvnfluKcp2nTC8mhV',
              type: 'Entry',
              createdAt: '2024-05-29T21:19:32.050Z',
              updatedAt: '2024-06-07T22:45:20.493Z',
              environment: null,
              publishedVersion: 10,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Learn how Flatfile can help (field-services)',
              buttonText: 'Learn how we can help',
              buttonUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=field-services',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ]
      }
    },
    timedCarouselHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '21JXZQhCnvRZhoaKSrWVPJ',
        type: 'Entry',
        createdAt: '2024-05-29T21:20:57.068Z',
        updatedAt: '2024-05-29T21:22:44.523Z',
        environment: null,
        publishedVersion: 4,
        revision: 2,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'No more costly, services-heavy data migration processes',
        heading: 'No more costly, services-heavy data migration processes',
        bodyText:
          "If you have customers using your software applications, loading those apps with data is a necessary first step before the customer will get any value from using your software or service. Any delay or complication in getting their data into your app will affect your customer's ROI and can impact your revenue."
      }
    },
    timedCarouselItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '1Fv0VTxaMq8qc25327yKqC',
          type: 'Entry',
          createdAt: '2024-05-29T21:24:21.638Z',
          updatedAt: '2024-06-27T19:30:08.070Z',
          environment: null,
          publishedVersion: 11,
          revision: 3,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Accelerate time-to-value (field services)',
          heading: 'Accelerate time-to-value',
          intro:
            'Get customer data into your systems faster with a data mapping and import experience your business needs and your users will love -- without delay or compromises.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7eryG6k4KY2yEEqhBXP2Wq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:17.532Z',
              updatedAt: '2024-06-27T19:24:17.532Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'accelerate time to value',
              description: null,
              file: {
                url: '/img/contentful/7eryG6k4-accelerate_time_to_value.webp',
                details: {
                  size: 15901,
                  image: {
                    width: 801,
                    height: 406
                  }
                },
                fileName: 'Accelerate Time to Value.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '1Fv0VTxaMq8qc25327yKqC',
          type: 'Entry',
          createdAt: '2024-05-29T21:24:21.638Z',
          updatedAt: '2024-06-27T19:30:08.070Z',
          environment: null,
          publishedVersion: 11,
          revision: 3,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Accelerate time-to-value (field services)',
          heading: 'Accelerate time-to-value',
          intro:
            'Get customer data into your systems faster with a data mapping and import experience your business needs and your users will love -- without delay or compromises.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '7eryG6k4KY2yEEqhBXP2Wq',
              type: 'Asset',
              createdAt: '2024-06-27T19:24:17.532Z',
              updatedAt: '2024-06-27T19:24:17.532Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'accelerate time to value',
              description: null,
              file: {
                url: '/img/contentful/7eryG6k4-accelerate_time_to_value.webp',
                details: {
                  size: 15901,
                  image: {
                    width: 801,
                    height: 406
                  }
                },
                fileName: 'Accelerate Time to Value.png',
                contentType: 'image/png'
              }
            }
          }
        }
      }
    ],
    gatedContentBox: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '5wnOmxVHRSfqkld4FOYN3s',
        type: 'Entry',
        createdAt: '2024-06-06T15:59:33.605Z',
        updatedAt: '2024-06-06T15:59:33.605Z',
        environment: null,
        publishedVersion: 8,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title:
          'The Customer Success Leader’s Guide to Successful Data Onboarding',
        heading:
          'The Customer Success Leader’s Guide to Successful Data Onboarding',
        intro:
          "Don't let your data onboarding process derail your new customer relationship before it's begun. Download this in-depth guide to find out how CS leaders can address data onboarding challenges and help new customers become customers for life.",
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: 'v3KmD8JLAM7hJuby6hF7n',
              type: 'Entry',
              createdAt: '2024-06-06T15:57:52.266Z',
              updatedAt: '2024-06-06T15:59:23.975Z',
              environment: null,
              publishedVersion: 8,
              revision: 2,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title:
                'Get the guide (The Customer Success Leader’s Guide to Successful Data Onboarding)',
              buttonText: 'Get the guide',
              buttonUrl:
                '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ],
        image: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '57a8cCP88lrlyhXkswDhUa',
            type: 'Asset',
            createdAt: '2024-05-31T16:06:04.592Z',
            updatedAt: '2024-05-31T16:06:04.592Z',
            environment: null,
            publishedVersion: 11,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'CS leaders guide to data onboarding-cover',
            description:
              "Cover of The Customer Success Leader's Guide to Successful Data Onboarding",
            file: {
              url: '/img/contentful/57a8cCP8-cs_leader-s_guide_to_successful_data_onboarding_cover.webp',
              details: {
                size: 125894,
                image: {
                  width: 1830,
                  height: 2232
                }
              },
              fileName:
                'CS leader-s guide to successful data onboarding cover.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    waterfallSectionHeader: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '39vie9pLO7t9tW3PGLrYvM',
        type: 'Entry',
        createdAt: '2024-05-29T21:32:22.336Z',
        updatedAt: '2024-05-29T21:32:22.336Z',
        environment: null,
        publishedVersion: 3,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        entryTitle: 'Seamless data onboarding with Flatfile',
        heading: 'Seamless data onboarding with Flatfile',
        bodyText:
          'The Flatfile Data Exchange Platform provides all the tools your customers and your implementation teams need for a seamless data onboarding experience.'
      }
    },
    waterfallSectionItems: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5cmnnmPZLsgebbq2n7yIDQ',
          type: 'Entry',
          createdAt: '2024-03-14T17:40:53.424Z',
          updatedAt: '2024-05-29T22:50:14.152Z',
          environment: null,
          publishedVersion: 5,
          revision: 2,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'The best of both worlds',
          heading: 'The best of both worlds',
          intro:
            'Adding a data exchange solution, like Flatfile, to your ETL processes will ensure that the right data reaches the right places in the right format, helping you to stay competitive and make informed, data-driven decisions.',
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '79InFYbz2Uxn1qxMVDhBRF',
              type: 'Asset',
              createdAt: '2024-03-14T17:40:42.687Z',
              updatedAt: '2024-03-14T17:40:42.687Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'core data exchange imagery',
              description: null,
              file: {
                url: '/img/contentful/79InFYbz-image_1.webp',
                details: {
                  size: 88632,
                  image: {
                    width: 808,
                    height: 508
                  }
                },
                fileName: 'image 1.png',
                contentType: 'image/png'
              }
            }
          }
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4sT9gltcUOp2alpLR6FEDL',
          type: 'Entry',
          createdAt: '2024-03-13T21:24:38.232Z',
          updatedAt: '2024-05-29T22:49:58.961Z',
          environment: null,
          publishedVersion: 11,
          revision: 3,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Test block',
          heading: 'wefwefwefwef',
          intro: 'This is a test',
          checklist: ['something', 'something else', 'yet another thing'],
          ctaLink: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '6cAoveIKPzUGnNQjCme8fK',
              type: 'Entry',
              createdAt: '2024-03-14T01:26:13.496Z',
              updatedAt: '2024-03-14T01:26:13.496Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'test link',
              linkText: 'Some link',
              linkUrl: '/demo'
            }
          },
          image: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5uHvl7LD2L3PKYcAlVlWI8',
              type: 'Asset',
              createdAt: '2024-02-14T02:55:59.362Z',
              updatedAt: '2024-02-14T02:55:59.362Z',
              environment: null,
              publishedVersion: 7,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'ETL and data file exchange',
              description:
                '"ETL and data file exchange" on a white background with images that represent ETL and data exchange',
              file: {
                url: '/img/contentful/5uHvl7LD-blog_post_-_dg2_-_top_6_data_import_challenges.webp',
                details: {
                  size: 80043,
                  image: {
                    width: 1920,
                    height: 1080
                  }
                },
                fileName: 'Blog Post - DG2 - Top 6 data import challenges.png',
                contentType: 'image/png'
              }
            }
          }
        }
      }
    ],
    webinarSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '1QHJRnxFxXmToAn5Eb4pj0',
        type: 'Entry',
        createdAt: '2024-05-29T21:35:09.881Z',
        updatedAt: '2024-05-29T21:35:09.881Z',
        environment: null,
        publishedVersion: 5,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title:
          'See how Flatfile streamlines data imports for faster customer onboarding',
        topHatText: 'WEBINAR',
        heading:
          'See how Flatfile streamlines data imports for faster customer onboarding',
        intro:
          'Field service teams are reclaiming their time by utilizing data exchange platforms like Flatfile to accelerate and simplify importing CSV files, Excel spreadsheets and many other file types from internal and external sources.',
        ctaButton: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '1JrHc3Y297fOvZXeVjdJMH',
              type: 'Entry',
              createdAt: '2024-05-29T21:34:22.278Z',
              updatedAt: '2024-05-29T21:34:22.278Z',
              environment: null,
              publishedVersion: 4,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              title: 'Get a personalized demo',
              buttonText: 'Get a personalized demo',
              buttonUrl: '/contact-sales/consult/',
              onPageAnchor: null,
              buttonStyle: 'Primary'
            }
          }
        ],
        video: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '6u2NlOeDWb3oQrJdBimlbh',
            type: 'Entry',
            createdAt: '2024-04-25T14:02:34.554Z',
            updatedAt: '2024-04-25T14:02:34.554Z',
            environment: null,
            publishedVersion: 2,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            title: 'Field Services',
            video: {
              items: [
                {
                  hashed_id: '94rr5br3he',
                  id: 118466398,
                  duration: 1830.08,
                  thumbnail: {
                    url: 'https://embed-ssl.wistia.com/deliveries/327aef979ec7e439a4323bdbaa2bd50f.jpg?image_crop_resized=200x120',
                    width: 200,
                    height: 120
                  }
                }
              ]
            }
          }
        }
      }
    },
    guidedBlocksSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '3VY6Wket36V4hKGi9nTJJi',
        type: 'Entry',
        createdAt: '2024-06-07T19:34:00.401Z',
        updatedAt: '2024-06-07T19:34:00.401Z',
        environment: null,
        publishedVersion: 4,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        internalName: 'Test guided blocks do not delete',
        topHatText: 'wewefwef',
        title: 'wefwefwef',
        bodyText: 'wefwefwef',
        cards: [
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '2rBmifbuFAsMnR4UuSoevp',
              type: 'Entry',
              createdAt: '2024-06-07T17:33:19.118Z',
              updatedAt: '2024-06-07T17:33:19.118Z',
              environment: null,
              publishedVersion: 5,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Demo (HCM)',
              title: 'Demo',
              bodyText: 'See how HCM companies are using Flatfile',
              linkText: 'Check it out',
              linkUrl:
                '/resources/webinars/how-ai-assisted-data-conversion-can-accelerate-implementation-projects/'
            }
          },
          {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: null,
              id: '5izMIaZj8rrKnq74gQ457m',
              type: 'Entry',
              createdAt: '2024-06-07T17:32:45.535Z',
              updatedAt: '2024-06-07T17:32:45.535Z',
              environment: null,
              publishedVersion: 6,
              revision: 1,
              contentType: null,
              locale: 'en-US'
            },
            fields: {
              internalName: 'Connect (hcm)',
              title: 'Connect',
              bodyText:
                'Learn how Flatfile transforms data onboarding as you know it',
              linkText: 'Connect with us',
              linkUrl:
                '/contact-sales/consult/?engagement_context_type=gtm-vertical-referral&engagement_context_value=hcm'
            }
          }
        ]
      }
    },
    platformOverviewHeading: 'Meet the Flatfile Data Exchange Platform',
    platformOverviewFeatures: [
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '4PY0isKBdPxOCChfUh8K7m',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:07.060Z',
          updatedAt: '2024-05-29T21:04:07.060Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Built for developers',
          intro:
            'Flatfile’s robust API, SDKs and code-based approach provide true flexibility and control, unlike low-code solutions. Seamlessly integrates into your existing infrastructure with Git-based configuration and source control.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '6Teayyzp67P0UYw9mK1VHv',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:29.399Z',
          updatedAt: '2024-05-29T21:04:29.399Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Intuitive for end users',
          intro:
            'The familiar spreadsheet-style interface highlights errors and streamlines tasks like search, find, replace and sort. It ensures a seamless experience with fully customizable workflows and theming to align perfectly with your process and brand.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '3NbyYdglQbzTy3cN2D62p5',
          type: 'Entry',
          createdAt: '2024-05-29T21:04:52.494Z',
          updatedAt: '2024-05-29T21:04:52.494Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Everything needed for file import',
          intro:
            'The industry’s most comprehensive data import experience at your fingertips, fully extensible with your own code. Import any data file type from any source. Clean data inconsistencies and formatting issues automatically.'
        }
      },
      {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: null,
          id: '5VSNemQ5JAxPbh1GIr0mZ7',
          type: 'Entry',
          createdAt: '2024-05-29T21:05:12.571Z',
          updatedAt: '2024-05-29T21:05:12.571Z',
          environment: null,
          publishedVersion: 3,
          revision: 1,
          contentType: null,
          locale: 'en-US'
        },
        fields: {
          title: 'Enterprise scale',
          intro:
            'Scalable and secure by default, Flatfile was built to meet rigorous enterprise security and compliance standards and provide the robust infrastructure necessary for large- scale data operations.'
        }
      }
    ],
    customerQuoteSection: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: null,
        id: '4Kg0ZuiQl4wecxvjilDFv1',
        type: 'Entry',
        createdAt: '2024-05-29T21:11:15.028Z',
        updatedAt: '2024-05-29T21:11:15.028Z',
        environment: null,
        publishedVersion: 6,
        revision: 1,
        contentType: null,
        locale: 'en-US'
      },
      fields: {
        title: 'Buildops Quote',
        theme: true,
        body: 'It’s one of the more important tools in our implementation toolbox. Without tools like Flatfile, scaling would be almost impossible.',
        quotee: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: 'uPXeGizgWEZvwU5GT520q',
            type: 'Entry',
            createdAt: '2024-05-29T21:08:42.768Z',
            updatedAt: '2024-05-29T21:08:42.768Z',
            environment: null,
            publishedVersion: 5,
            revision: 1,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            fullName: ' Scott Patterson',
            headshot: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '683Iy5HG9J0IIX6mLsjhrU',
                type: 'Asset',
                createdAt: '2024-05-29T21:08:11.296Z',
                updatedAt: '2024-05-29T21:08:11.296Z',
                environment: null,
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'workday-photo',
                description: null,
                file: {
                  url: '/img/contentful/683Iy5HG-workday-photo.webp',
                  details: {
                    size: 960220,
                    image: {
                      width: 961,
                      height: 960
                    }
                  },
                  fileName: 'workday-photo.png',
                  contentType: 'image/png'
                }
              }
            },
            jobTitle: 'Director of Implementation',
            company: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: null,
                id: '6mV1CXFczPDzORxRwEhTTM',
                type: 'Entry',
                createdAt: '2024-01-02T22:09:30.412Z',
                updatedAt: '2025-04-08T22:31:49.207Z',
                environment: null,
                publishedVersion: 24,
                revision: 6,
                contentType: null,
                locale: 'en-US'
              },
              fields: {
                name: 'BuildOps',
                logo: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '6Ys8olKZa4ZocR2sxpahr2',
                    type: 'Asset',
                    createdAt: '2024-01-03T17:35:23.409Z',
                    updatedAt: '2024-01-03T18:09:04.577Z',
                    environment: null,
                    publishedVersion: 15,
                    revision: 2,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'BuildOps_logo',
                    description: 'BuildOps logo',
                    file: {
                      url: '/img/contentful/6Ys8olKZ-buildops_logo_final.webp',
                      details: {
                        size: 70470,
                        image: {
                          width: 1629,
                          height: 258
                        }
                      },
                      fileName: 'BuildOps_Logo_final.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                logoBlack: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '1NKL9mMoLhx7nSwAZaTSKe',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.128Z',
                    updatedAt: '2024-04-29T20:24:29.128Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'buildops',
                    file: {
                      url: '/img/contentful/1NKL9mMo-buildops.webp',
                      details: {
                        size: 10706,
                        image: {
                          width: 280,
                          height: 56
                        }
                      },
                      fileName: 'buildops.png',
                      contentType: 'image/png'
                    }
                  }
                },
                logoWhite: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '1NKL9mMoLhx7nSwAZaTSKe',
                    type: 'Asset',
                    createdAt: '2024-04-29T20:24:29.128Z',
                    updatedAt: '2024-04-29T20:24:29.128Z',
                    environment: null,
                    publishedVersion: 2,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'buildops',
                    file: {
                      url: '/img/contentful/1NKL9mMo-buildops.webp',
                      details: {
                        size: 10706,
                        image: {
                          width: 280,
                          height: 56
                        }
                      },
                      fileName: 'buildops.png',
                      contentType: 'image/png'
                    }
                  }
                },
                coverPhoto: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: null,
                    id: '3WAtTZSZa1HuLu6aClnoTg',
                    type: 'Asset',
                    createdAt: '2024-01-03T20:03:13.745Z',
                    updatedAt: '2024-01-03T20:03:13.745Z',
                    environment: null,
                    publishedVersion: 3,
                    revision: 1,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'danist-soh-8Gg2Ne uTcM-unsplash',
                    description: null,
                    file: {
                      url: '/img/contentful/3WAtTZSZ-danist-soh-8gg2ne_utcm-unsplash.webp',
                      details: {
                        size: 2885032,
                        image: {
                          width: 4808,
                          height: 3205
                        }
                      },
                      fileName: 'danist-soh-8Gg2Ne_uTcM-unsplash.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                location: 'San Francisco, California ',
                industry: 'Field service management software',
                department: ['Support', 'Sales'],
                keyFeaturesUsed: ['AI apps', 'Knowledge Graph', 'Style Guide'],
                website: 'buildops.com'
              }
            }
          }
        },
        photo: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '683Iy5HG9J0IIX6mLsjhrU',
            type: 'Asset',
            createdAt: '2024-05-29T21:08:11.296Z',
            updatedAt: '2024-05-29T21:08:11.296Z',
            environment: null,
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'workday-photo',
            description: null,
            file: {
              url: '/img/contentful/683Iy5HG-workday-photo.webp',
              details: {
                size: 960220,
                image: {
                  width: 961,
                  height: 960
                }
              },
              fileName: 'workday-photo.png',
              contentType: 'image/png'
            }
          }
        },
        ctaLink: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: null,
            id: '4DY7xQys161myJxi2mp6sO',
            type: 'Entry',
            createdAt: '2024-05-29T21:11:02.926Z',
            updatedAt: '2024-06-14T17:20:14.301Z',
            environment: null,
            publishedVersion: 7,
            revision: 3,
            contentType: null,
            locale: 'en-US'
          },
          fields: {
            title:
              'Learn more about how BuildOps decreased customer activation time by 20% with Flatfile',
            linkText:
              'Learn more about how BuildOps decreased customer activation time by 20% with Flatfile',
            linkUrl:
              '/resources/case-studies/buildops-clears-data-import-bottleneck-with-flatfile/'
          }
        }
      }
    },
    showWayfinder: null
  }
] as const

export type VerticalLandingPage = (typeof verticalLandingPageData)[number]

export default verticalLandingPageData
